// Demo i18n config (UA/EN)

const resources = {
  en: {
    translation: {
      "calculator.title": "Ringostat Services Cost Calculator",
      "calculator.monthlyCost": "Monthly Service Cost",
      "calculator.addProduct": "Add product",
      "calculator.users": "Business Phone users",
      "calculator.usersLabel": "Users",
      "calculator.usersInputLabel": "Business Phone users",
      "calculator.sessions": "Call Tracking sessions/day",
      "calculator.sessionsLabel": "Sessions",
      "calculator.sessionsInputLabel": "Call Tracking sessions/day",
      "calculator.total": "Estimated total",
      "calculator.totalPerMonth": "Total per month",
      "calculator.generateOffer": "Generate Offer",
      "calculator.placeholderAdd": "Add at least one product to calculate the cost",
      "calculator.selectRegion": "Select region",
      "calculator.callTracking": "Call Tracking",
      "calculator.businessPhone": "Business Phone",
      "calculator.ai": "AI Conversation Intelligence",
      "calculator.callback": "Callback",
      "calculator.aiMinutesInputLabel": "AI analysis minutes",
      "calculator.callbackSessionsInputLabel": "Callback sessions",
      "calculator.addProductsTitle": "Add Products",
      "calculator.selectedProductsTitle": "Selected Products",
      "calculator.phoneNumbers": "Phone Numbers",
      "calculator.addMore": "+ Add More",
      "calculator.allProductsSelected": "You have selected all available products! 🎉",
      "calculator.addPhoneNumbers": "Add Phone Numbers",
      "calculator.editPhoneNumbers": "Edit Phone Numbers",
      "calculator.quantity": "Quantity",
      "calculator.pricePerNumber": "Price per Number",
      "calculator.add": "Add",
      "calculator.update": "Update",
      "calculator.estimatedTotal": "Estimated total",
      "calculator.offerPageTitle": "Offer (Demo)",
      "calculator.offerPageDesc": "This page will show a generated commercial offer for the client with Ringostat branding.",
      "calculator.summary": "Summary",
      "calculator.noItemsSelected": "No items selected",
      "calculator.addProducts": "Add Products",
      "calculator.voiceTraffic": "Voice Traffic",
      "calculator.aiConversation": "AI Conversation Intelligence",
      "calculator.omnichannelChat": "Omnichannel Chat",
      "calculator.voiceTrafficPackageUA": "Minutes Package UA",
      "calculator.voiceTrafficPackageKZ": "Minutes Package KZ",
      "calculator.voiceTrafficPackageTooltip": "Select a package manually or let the system choose the most cost-effective one",
      "calculator.voiceTrafficSelectedPackages": "Selected packages",
      "calculator.voiceTrafficCustomAmount": "Deposit for outbound calls",
      "calculator.voiceTrafficSettings": "Voice Traffic Settings",
      "calculator.voiceTrafficCountries": "Countries", 
      "calculator.voiceTrafficCountriesDescription": "Select countries for voice traffic packages. You can select multiple countries.",
      "calculator.voiceTrafficCustomAmountDescription": "Use a custom amount instead of automatic package selection",
      "calculator.voiceTrafficSummary": "The system will automatically select the best packages for {{count}} countries based on your minute requirements.",
      "calculator.voiceTrafficSelectedCountries": "Selected countries: {{countries}}",
      "calculator.voiceTrafficCustomAmountInput": "Deposit for calls",
      "calculator.voiceTrafficPackageDetails": "{{includedMinutes}} minutes included",
      "calculator.voiceTrafficOverageMinutes": "extra minutes",
      "calculator.voiceTrafficOverageText": "min. over package",
      "calculator.voiceTrafficOverageShort": "over package",
      "calculator.voiceTrafficPerMinute": "UAH per min",
      "calculator.voiceTrafficCurrencyUAH": "UAH per min",
      "calculator.voiceTrafficCurrencyKZT": "KZT per min",
      "calculator.voiceTrafficCurrencyPLN": "PLN per min",
      "calculator.voiceTrafficCurrencyEUR": "€/min",
      "calculator.voiceTrafficVolumeUA": "Outbound call volume in Ukraine",
      "calculator.voiceTrafficVolumeKZ": "Outbound call volume in Kazakhstan",
      "calculator.voiceTrafficVolumePL": "Outbound call volume in Poland",
      "calculator.voiceTrafficMinutesShort": "min.",
      "calculator.voiceTrafficMinutesUnit": "minutes",
      "calculator.voiceTrafficPackage": "Package",
      "calculator.voiceTrafficMinutes": "minutes",
      "countries.ukraine": "Ukraine",
      "countries.kazakhstan": "Kazakhstan", 
      "countries.poland": "Poland",
      "voicePackages.noPackagesHint": "Some countries are unavailable — no active minute packages configured",
      "voicePackages.title": "Voice Packages",
      "voicePackages.subtitle": "Manage voice traffic minute packages",
      "voicePackages.addPackage": "Add Package",
      "voicePackages.editPackage": "Edit Voice Package",
      "voicePackages.showingEntries": "Showing {{showing}} of {{total}} entries",
      "voicePackages.confirmDelete": "Delete Package?",
      "voicePackages.confirmDeleteText": "Are you sure you want to delete \"{{name}}\" ({{country}})?",
      "voicePackages.country": "Country",
      "voicePackages.allCountries": "All",
      "voicePackages.searchPlaceholder": "Search name...",
      "voicePackages.name": "Name",
      "voicePackages.minutes": "Minutes",
      "voicePackages.priceLocal": "Price Local",
      "voicePackages.currency": "Currency",
      "voicePackages.priceUsd": "Price USD",
      "voicePackages.perMinLocal": "Per Min Local",
      "voicePackages.perMinUsd": "Per Min USD",
      "voicePackages.overageLocal": "Overage Local",
      "voicePackages.overageUsd": "Overage USD",
      "voicePackages.active": "Active",
      "voicePackages.actions": "Actions",
      "voicePackages.edit": "Edit",
      "voicePackages.delete": "Delete",
      "voicePackages.loading": "Loading packages...",
      "voicePackages.noEntries": "No packages found",
      "voicePackages.adjustFilters": "Try adjusting your filters",
      "voicePackages.pricePerMinuteLocal": "Price Per Minute Local",
      "voicePackages.overageRateLocal": "Overage Rate Local",
      "voicePackages.isActive": "Active",
      "voicePackages.usdInfo": "USD prices are updated automatically by the daily cron job",
      "voicePackages.fetchError": "Failed to load voice packages",
      "voicePackages.updated": "Package updated",
      "voicePackages.created": "Package created",
      "voicePackages.deleted": "Package deleted",
      "voicePackages.deleteError": "Failed to delete package",
      "voicePackages.toggleError": "Failed to toggle active status",
      "calculator.businessPhoneDesc": "Number of users needing business phone features",
      "calculator.callTrackingDesc": "Daily website sessions",
      "calculator.aiConversationDesc": "Number of minutes to analyze per month",
      "calculator.callbackDesc": "Estimated monthly callback requests",
      "calculator.phoneNumbersDesc": "Purchase and manage phone numbers",
      "calculator.voiceTrafficDesc": "Number of voice traffic minutes per month",
      "calculator.omnichannelChatDesc": "Users for online chat + messengers (Viber, Telegram, Facebook)",
      "calculator.betaProduct": "BETA -50%",
      "calculator.betaPricing": "Beta pricing: 50% discount applied",
      "calculator.omnichannelChatWarning": "Omnichannel Chat requires Business Phone to be added first.",
      "calculator.omnichannelChatWarning.title": "Product Requirements",
      "calculator.omnichannelChatFmcInfo": "Omnichannel Chat is available only with Business Phone. With FMC editing is unavailable.",
      "calculator.omnichannelChatLimitInfoWithValue": "Chat maximum is {{max}} (equals Business Phone users). To enter a larger value in the input, first increase Business Phone.",
      "common.ok": "OK",
      "common.reset": "Reset",
      "calculator.minute": "minute",
      "calculator.pricePerMinute": "Price per minute",
      "calculator.totalPrice": "Total price",
      "calculator.customSettingsEnabled": "Custom settings enabled",
      "calculator.aiSettingsTitle": "AI Conversation Intelligence Settings",
      "calculator.enableNonEnglishAnalysis": "Enable Non-English Analysis",
      "calculator.nonEnglishAnalysisTooltip": "Unified pricing: $0.03 per minute for all regions (except Europe: €0.03)",
      "calculator.resetToDefault": "Reset to Default",
      "calculator.apply": "Apply",
      "calculator.cancel": "Cancel",
      "calculator.pricingInformation": "Pricing Information:",
      "calculator.standardAnalysis": "Standard Analysis:",
      "calculator.nonEnglishAnalysis": "Non-English Analysis:",
      "calculator.monthlyTotal": "Monthly cost",
      "calculator.paymentOptions": "Payment Options",
      "calculator.paymentSummary": "Payment Summary",
      "calculator.standardPlan": "360 days",
      "calculator.bestValue": "Best value - ",
      "calculator.sixMonthPlan": "180 days subscription",
      "calculator.threeMonthMinimum": "90 days subscription",
      "calculator.monthlyContract": "12-month contract",
      "calculator.splitPayment": "360 days subscription (split payment)",
      "calculator.moreExpensivePerYear": "more expensive per year",
      "calculator.businessPhoneUsers": "users",
      "calculator.fmcUsers": "users",
      "calculator.advancedDiscountSettings": "Advanced Discount Settings",
      "calculator.discount360Days": "360-day discount",
      "calculator.discount180Days": "180-day discount", 
      "calculator.advancedDiscountHint": "Press Cmd+Shift+D (Mac) or Ctrl+Shift+D (PC) to hide",
      "calculator.businessPhoneUsersLabel": "Number of business phone users",
      "calculator.businessPhoneUsersLabelStandalone": "Number of users",
      "calculator.fmcUsersLabel": "Number of FMC users",
      "calculator.fmcUsersLabelStandalone": "Number of users",
      "calculator.callTrackingSlots": "slots",
      "calculator.aiMinutes": "minutes",
      "calculator.callbackSessions": "sessions",
      "calculator.phoneNumbersCount": "numbers",
      "calculator.businessPhoneLabel": "Business Phone",
      "calculator.fmcLabel": "FMC",
      "calculator.callTrackingLabel": "Call Tracking",
      "calculator.aiConversationLabel": "AI Conversation Intelligence",
      "calculator.callbackLabel": "Callback",
      "calculator.voiceTrafficLabel": "Voice Traffic",
      "calculator.chatUsers": "users",
      "calculator.chatUsersLabel": "Number of users",
      "calculator.businessPhoneSettings": "Business Phone Settings",
      "calculator.businessPhoneType": "Business Phone Type",
      "calculator.businessPhoneOnly": "Business Phone",
      "calculator.fmcOnly": "FMC",
      "calculator.businessPhoneFmc": "Business Phone + FMC",
      "calculator.businessPhonePricing": "Business Phone: €20 per user",
      "calculator.fmcPricing": "FMC: $5 per user",
      "calculator.comparePlans": "Compare",
      "calculator.compareFeatures": "Compare features",
      "calculator.comparePlansTitle": "Plan Comparison",
      "calculator.feature": "Feature",
      "calculator.selected": "Selected",
      "calculator.compareTip": "Click on a plan column to select it",
      "calculator.included": "INCLUDED",
      "calculator.includedInTier": "Included in your {{tier}} plan",
      "calculator.includedInProCorporate": "Included in Pro/Corporate",
      "calculator.perUser": "/user",
      "calculator.comingSoon": "Coming Soon",
      "calculator.uaBusinessDiscount": "Discount for Ukrainian business",
      "calculator.features.aiConversation": "Conversation Intelligence (AI)",
      "calculator.features.aiConversationBasicLevel": "Basic",
      "calculator.features.aiConversationProLevel": "Professional Eniq AI",
      "calculator.features.omnichannelChat": "Omnichannel Chat",
      "calculator.features.callback": "Callback",
      "calculator.features.realTimeReports": "Real-time Reports",
      "calculator.features.agentStatuses": "Agent Statuses",
      "calculator.features.callWhisper": "Call Whisper",
      "calculator.features.csat": "CSAT",
      "calculator.features.customerSuccessTeam": "Customer Success Team",
      "calculator.features.powerDialer": "Power Dialer",
      "calculator.features.autoMissedProcessing": "Missed Calls Automation",
      "calculator.features.prioritySupport": "Priority Support",
      "calculator.features.dedicatedVipCs": "Dedicated Customer Success (VIP)",
      "calculator.features.customLookerReports": "Custom Looker Studio Reports",
      "calculator.features.customUserRoles": "Custom user roles",
      "calculator.features.customCrmIntegration": "Custom CRM Integration",
      "calculator.eniqCompare.title": "Eniq AI plan comparison",
      "calculator.eniqCompare.note": "Price is per user per month",
      "calculator.eniqCompare.models": "AI models",
      "calculator.eniqCompare.modelsStandard": "Standard models",
      "calculator.eniqCompare.modelsPro": "Premium models",
      "calculator.eniqCompare.promptLimit": "Analysis prompt length",
      "calculator.eniqCompare.promptLimitStandard": "Up to 30k characters",
      "calculator.eniqCompare.promptLimitPro": "No limit",
      "calculator.eniqCompare.insights": "AI Insights",
      "calculator.eniqCompare.insightsStandard": "Standard limits",
      "calculator.eniqCompare.insightsPro": "Extended limits",
      "calculator.eniqCompare.knowledgeBase": "Knowledge base",
      "calculator.eniqCompare.knowledgeBaseStandard": "Standard limits",
      "calculator.eniqCompare.knowledgeBasePro": "Extended limits",
      "calculator.eniqCompare.training": "AI Training",
      "calculator.eniqCompare.trainingStandard": "1 hour per user",
      "calculator.eniqCompare.trainingPro": "Extended limit",
      "calculator.eniqTierLabel": "Eniq AI plan",
      "calculator.eniqTierStandard": "Standard",
      "calculator.eniqTierPro": "Pro",
      "calculator.eniqUsersLabel": "Number of users",
      "calculator.eniqUsersLinkedInfo": "Eniq AI users are linked to Business Phone/FMC users count",
      "calculator.eniqUpgradeDiff": "Standard is included in Corporate — you only pay the difference",
      "calculator.eniqMinBillableUsers": "Eniq AI is always billed for a minimum of {{count}} users",
      "calculator.fmcRegionWarning.title": "Region Change Warning",
      "calculator.fmcRegionWarning.message": "You are switching to a region where FMC product is not supported. FMC will be removed from your selection. Do you want to continue?",
      "calculator.fmcRegionWarning.confirm": "Change Region",
      "common.cancel": "Cancel",
      "common.apply": "Apply",
      "common.save": "Save",
      "common.create": "Create",
      "common.delete": "Delete",
      "calculator.callTrackingSettings": "Call Tracking Settings",
      "calculator.trackingType": "Tracking Type",
      "calculator.dynamicTracking": "Dynamic (based on sessions)",
      "calculator.staticTracking": "Static (fixed sources)",
      "calculator.combinedTracking": "Combined (dynamic + static)",
      "calculator.enableCallMeButton": "Enable Call Me Button",
      "calculator.numberFormatsQuantity": "Number formats quantity",
      "calculator.globalSettings": "Global Settings",
      "calculator.globalSettingsPlaceholder": "Global settings will be available here",
      "calculator.showAdvancedTier": "Show Advanced Tier",
      "calculator.showAdvancedTierDescription": "Enable the hidden Advanced tier for Business Phone (UA, Central Asia, Other regions)",
      "calculator.showPricesWithoutBonuses": "Display prices without long-term bonuses",
      "calculator.showPricesWithoutBonusesDescription": "Monthly fee forecast will show prices without 360-day subscription discount",
      "calculator.subscriptionOptions": "Subscription Options",
      "calculator.subscription12Month": "12-Month Contract",
      "calculator.subscriptionSplitPayment": "Split Payment",
      "calculator.legacyOptions": "Legacy Options",
      "calculator.subscription90Days": "90 Days Subscription",
      "calculator.subscription180Days": "180 Days Subscription",
      "calculator.phoneNumberName": "Phone Number Name",
      "calculator.unitPrice": "Unit Price",
      "calculator.noPhoneNumbers": "No phone numbers added yet. Click \"Add phone number\" to add one.",
      "calculator.addPhoneNumber": "Add phone number",
      "calculator.addFromCatalog": "Add from Catalog",
      "calculator.phoneCatalog": "Phone Number Catalog",
      "calculator.addToOffer": "Add to offer",
      "calculator.itemsSelected": "{{count}} selected",
      "calculator.fromPrice": "FROM",
      "calculator.fromPriceHint": "Price starts from this amount",
      "calculator.noResults": "No numbers found",
      "calculator.fromCatalog": "From catalog",
      "calculator.phoneNamePlaceholder": "Type to search catalog...",
      "calculator.selectCountry": "Country",
      "calculator.selectCity": "City",
      "calculator.selectProvider": "Provider",
      "calculator.searchNumbers": "Search...",
      "calculator.monthlyFee": "Monthly",
      "calculator.country": "Country",
      "calculator.city": "City",
      "calculator.provider": "Provider",
      "calculator.code": "Code",
      "calculator.currency": "Cur.",
      "calculator.docsShort": "Docs",
      "calculator.commentShort": "Note",
      "calculator.requiredDocs": "Required documents",
      "calculator.commentTitle": "Note",
      "calculator.freeForTrial": "Free trial",
      "calculator.freeForTrialYes": "Free for trial",
      "calculator.docsRequired": "Documents required",
      "admin.syncDIDWW": "Sync DIDWW Docs",
      "admin.syncDIDWWSyncing": "Syncing...",
      "admin.syncDIDWWSuccess": "Synced {{countries}} countries, updated {{entries}} entries",
      "admin.syncDIDWWError": "Failed to sync DIDWW requirements",
      "admin.syncDIDWWStarted": "DIDWW sync started, please wait...",
      "admin.syncDIDWWAlreadyRunning": "Sync already in progress",
      "calculator.pleaseEnterName": "Please enter a name for the phone number",
      "calculator.allProductsAdded": "All available products have been added",
      "calculator.dailyWebsiteSessions": "Daily website sessions",
      "calculator.staticSourcesDescription": "Static sources (1 source = 1 phone number)",
      "calculator.minutesToAnalyze": "Number of minutes to analyze per month",
      "calculator.aiUsersLabel": "Number of users",
      "calculator.aiUsersLinkedInfo": "AI users are linked to Business Phone/FMC users count",
      "calculator.chatUsersLinkedInfo": "Chat users are linked to Business Phone users count (FMC users cannot use chat)",
      "calculator.phoneNumbersRequired": "Phone numbers required",
      "calculator.minutes": "minutes",
      "calculator.numbers": "numbers",
      "Settings": "Settings",
      "Region": "Region",
      "Initial Data": "Initial Data",
      "Service Cost": "Service Cost",
      "Business Phone": "Business Phone",
      "Call Tracking": "Call Tracking",
      "Total": "Total",
      "offers.notIncluded": "Not included",
      "offers.included": "Included",
      "offers.notAvailable": "Not available",
      "offers.perMonth": "/mo",
      "offers.backToCalculator": "Back to Calculator",
      "offers.offerDetails": "Offer Details",
      "offers.comparisonCount": "Comparison ({{count}}/5)",
      "offers.offersComparison": "Offers Comparison",
      "offers.offersComparisonFor": "Offers Comparison for {{companyName}}",
      "offers.proposalFor": "Proposal '{{offerName}}' for {{companyName}}",
      "offers.proposalForCompany": "Proposal for {{companyName}}",
      "offers.proposalDetails": "Proposal '{{offerName}}'",
      "offers.reviewOfferDetails": "Review your offer details and choose a pricing plan",
      "offers.currencyDisclaimer": "Pricing is in USD, payment in UAH at the current exchange rate on the day of payment",
      "comparison.noCompanyName": "No company name",
      "offers.compareOffersDescription": "Compare different offers and choose the best one for your business",
      "offers.offer": "Offer",
      "offers.productsAndUsage": "Products and Usage",
      "offers.subscriptionOptions": "Subscription Options",
      "offers.available": "Available",
      "offers.exportToPDF": "Export to PDF",
      "offers.validUntil": "Valid until {{date}}",
      "offers.validUntilShort": "valid until",
      "offers.validityPeriod": "14 days from generation date",
      "offers.toPay": "to pay",
      "offers.savePerYear": "Save",
      "offers.perYear": "/year",
      "offers.plan360days20": "360 days (20% bonus)",
      "offers.savings": "Savings",
      "offers.annualPayment": "annual payment",
      "offers.plan360daysNoBonus": "360 days (no bonus)",
      "offers.plan180days": "180 days (10% bonus)",
      "offers.plan90days": "90 days",
      "offers.plan12month": "12-month contract",
      "offers.plan360split": "360 days (split payment)",
      "offers.semiAnnualPayment": "for 6 months",
      "offers.detailedOffer": "Detailed Offer",
      "offers.removeFromComparison": "Remove from Comparison",
      "offers.noOffersToCompare": "No offers to compare",
      "offers.returnToCalculatorToCreate": "Return to calculator to create new offers",
      "calculator.aiConversationCalls": "calls",
      "common.backToCalculator": "Back to Calculator",
      "history.title": "Offers History",
      "history.description": "View and manage all your generated offers and comparisons",
      "history.dateTime": "Date & Time",
      "history.type": "Type",
      "history.userEmail": "User Email",
      "history.link": "Link",
      "history.offer": "Offer",
      "history.comparison": "Comparison",
      "history.noHistory": "No comparisons yet",
      "history.createFirst": "Create your first comparison in the calculator",
      "history.openInNewTab": "Open in new tab",
      "history.copyLink": "Copy link",
      "history.useAsTemplate": "Use as template",
      "history.templateUnavailable": "Template data unavailable",
      "history.copied": "Copied!",
      "history.offers": "offers",
      "history.offersInComparison": "Offers in this comparison",
      "history.clientName": "Company Name",
      "history.searchByClientName": "Search by company name...",
      "history.noClientName": "No company name",
      "history.filters": "Filters",
      "history.selectDateRange": "Select date range",
      
      // Додаткові переклади для offers
      "offers.generateOffer": "Generate Offer",
      "offers.selectTabsDescription": "Select the pricing configurations you want to include in your offer:",
      "offers.selectAll": "Select All",
      "offers.configuration": "Configuration",
      "offers.generateComparison": "Generate Comparison",
      "offers.offerGenerated": "Offer Generated!",
      "offers.offerGeneratedDescription": "Your pricing offer has been created successfully",
      "offers.offerLink": "Offer Link:",
      "offers.offerShareInfo": "Share this link with your clients to show them the detailed pricing offer.",
      "offers.comparisonGenerated": "Comparison Generated!",
      "offers.comparisonGeneratedDescription": "Your pricing comparison has been created successfully",
      "offers.comparisonLink": "Comparison Link:",
      "offers.comparisonShareInfo": "Share this link with your clients to show them the comparison of different pricing options.",
      "offers.copyLink": "Copy Link",
      "offers.openInNewTab": "Open in New Tab",
      "offers.linkCopied": "Link copied to clipboard!",
      "offers.yourProposal": "Your Proposal",
      "offers.monthlyForecast": "Monthly fee forecast",
      "offers.chooseThisPlan": "Choose this plan",
      "offers.monthlyCost": "Monthly cost",
      "calculator.monthlyForecast": "Monthly fee forecast",
      "offers.clientName": "Company Name *",
      "offers.clientNamePlaceholder": "Enter company name...",
      "offers.clientNameRequired": "Company name is required",
      "offers.generating": "Generating...",
      "offers.noTabsAvailable": "No pricing configurations available",
      
      // Додаткові переклади для common
      "common.close": "Close",

      // Переклади для сторінки логіну
      "login.title": "Login to Ringostat Pricing Calculator",
      "login.welcome": "Use your corporate Google account (@ringostat.com)",
      "login.continueWithGoogle": "Continue with Google",

      // Переклади для підписок
      "subscription.360Days": "360 days (bonus 20%)",
      "subscription.360DaysCustom": "360 days (bonus {{discount}}%)",
      "subscription.360DaysNoBonus": "360 days",
      "subscription.180Days": "180 days",
      "subscription.180DaysCustom": "180 days (bonus {{discount}}%)",
      "subscription.90Days": "90 days",
      "subscription.12MonthContract": "12-monthly contract",
      "subscription.360DaysSplit": "360 days (installment)",
      "subscription.toPay": "to pay",
      "subscription.savings": "Savings",
      "subscription.perYear": "/year",
      "subscription.perMonth": "/mo", 
      "subscription.days": "days",
      "subscription.bonus": "bonus",
      "subscription.splitPayment": "split payment",
      "subscription.vatIncluded": "Including VAT 20%: {{amount}}",
      
      // Переклади для Eniq AI
      "calculator.eniqAiLabel": "Eniq AI",
      "calculator.eniqAiDesc": "AI-powered conversation analysis",
      "calculator.eniqAiMinutes": "Analysis minutes",
      "calculator.eniqAiMinutesInput": "Number of minutes",
      "calculator.eniqAiUnits": "units",
      "calculator.eniqAiPremiumModels": "Premium models",
      "calculator.eniqAiSettings": "Eniq AI Settings",
      "calculator.eniqAiAnalysisType": "Analysis Type",
      "calculator.eniqAiPremiumDescription": "Higher accuracy analysis with advanced AI models (1 credit per minute)",
      "calculator.eniqAiStandardNote": "Standard models",
      "calculator.eniqAiStandardDescription": "Cost-effective analysis with standard AI models (0.33 credits per minute)",
      "calculator.eniqAiDescription": "AI-powered conversation analysis with flexible pricing plans based on your usage needs.",
      "calculator.eniqAiOptimalPlan": "Optimal plan",
      "calculator.eniqAiIncluded": "minutes included",
      "calculator.eniqAiExtraMinutes": "extra minutes",
      "calculator.eniqAiUnitsIncluded": "units included",
      "calculator.eniqAiExtraUnits": "extra units",
      "calculator.eniqAiTariff": "Plan",
      // Advanced Settings
      "calculator.advancedSettings": "Advanced Settings",
      "calculator.veryCustomProductDiscount": "Custom Product Discount",
      "calculator.customDiscountNote": "Applied after bundle discounts (0-100%)",
      "calculator.advancedSettingsHint": "Access: Double-click title or Ctrl+Shift+C",
      "calculator.omnichannelChatSettings": "Omnichannel Chat Settings",
      "calculator.omnichannelChatSettingsDescription": "Currently there are no additional settings available for Omnichannel Chat.",
      "calculator.eniqAiCalculationError": "Failed to calculate pricing",
      "calculator.calculating": "Calculating...",
      
      // Eniq AI Plan Names
      "calculator.eniqAiPlanStart": "Start",
      "calculator.eniqAiPlanPro": "Pro",
      "calculator.eniqAiPlanMax": "Max",
      "calculator.eniqAiPlanScale": "Scale",

      // VoiceBot
      "calculator.voicebotLabel": "Voice bot",
      "calculator.voicebotDesc": "AI-powered automated calls",
      "calculator.voicebotMinutesInput": "Number of minutes",
      "calculator.voicebotMinutesUnit": "min",
      "calculator.voicebotSettings": "VoiceBot Settings",
      "calculator.voicebotMode": "Campaign Mode",
      "calculator.voicebotAiMode": "AI VoiceBot",
      "calculator.voicebotAiDescription": "AI-powered voice conversations (1000 units per minute)",
      "calculator.voicebotRoboCallMode": "RoboCall",
      "calculator.voicebotRoboCallDescription": "Automated calls without AI (100 units per minute)",
      "calculator.voicebotExtraChannels": "Extra Robo-Channels",
      "calculator.voicebotChannelsIncluded": "3 channels included in every plan",
      "calculator.voicebotExtraChannelsCount": "Additional channels",
      "calculator.voicebotChannelPrice": "$25/month per channel",
      "calculator.voicebotTotalChannels": "total channels",
      "calculator.voicebotPerMonth": "mo",
      "calculator.voicebotImplementationFee": "Implementation Fee",
      "calculator.voicebotImplementationFeeLabel": "VoiceBot Implementation",
      "calculator.voicebotImplementationFeeDesc": "One-time fee for VoiceBot implementation and setup",
      "calculator.voicebotMinIncluded": "min included",
      "calculator.voicebotExtraMin": "extra min",
      "calculator.planLite": "Lite",
      "calculator.tariff": "Tariff",

      // Переклади для валютного селектора
      "currency.display": "Currency",
      "currency.uahNote": "Prices are set in dollars, payment is made in hryvnias at the exchange rate on the day of payment.",
      "currency.uah": "UAH",
      "currency.uahSymbol": "UAH",
      "currency.usd": "USD",
      "currency.eur": "EUR",
      
      // Короткий переклад для періоду
      "calculator.perMonthShort": "/mo",
      
      // Одноразові платежі
      "calculator.oneTimePayments": "One-time payments",
      "calculator.phoneNumberActivation": "Phone numbers activation",
      "calculator.eniqImplementationFee": "Eniq AI Implementation",
      "calculator.enableImplementationFee": "Implementation fee",
      "calculator.implementationFeeDescription": "One-time fee for Eniq AI implementation and setup",
      "calculator.implementationFeeAmount": "Implementation fee amount",
      
      // Phone Numbers Settings
      "calculator.phoneNumbersSettings": "Phone Numbers Settings",
      "calculator.enablePhoneActivation": "Enable activation fee",
      "calculator.activationFee": "Activation",
      "calculator.activationTotal": "Activation fee",
      
      // Date Picker
      "datePicker.today": "Today",
      "datePicker.yesterday": "Yesterday",
      "datePicker.last7Days": "Last 7 days",
      "datePicker.last30Days": "Last 30 days",
      "datePicker.currentMonth": "Current month",
      "datePicker.previousMonth": "Previous month",
      "datePicker.selectDateRange": "Select Date Range",
      "datePicker.quickSelect": "Quick Select",
      "datePicker.customRange": "Custom Range",
      "datePicker.from": "From",
      "datePicker.to": "To",
      "datePicker.clear": "Clear",

      // Selected Plan Features
      "calculator.selectedPlanIncludes": "Selected Plan Includes",

      // Basic tier features
      "calculator.feature.mobileDesktopApps": "Desktop & mobile apps",
      "calculator.feature.callRecordingUnlimited": "Unlimited call recording",
      "calculator.feature.integrations50": "50+ ready integrations",
      "calculator.feature.reportsControlMissed": "Reports & statistics",
      "calculator.feature.flexibleRouting": "Flexible call routing",
      "calculator.feature.ivrVoicemail": "IVR, voicemail",

      // Pro tier features
      "calculator.feature.allBasicFeatures": "All Basic plan features",
      "calculator.feature.callTranscription": "Call transcription",
      "calculator.feature.aiQualityScoring": "AI call quality scoring",
      "calculator.feature.omnichannelMessengers": "Chat & messengers",
      "calculator.feature.callbackWidget": "Callback widget",
      "calculator.feature.advancedReportsSchedule": "Advanced reporting",

      // Corporate tier features
      "calculator.feature.allProFeatures": "All Pro plan features",
      "calculator.feature.advancedConversationAnalytics": "Advanced conversation analytics",
      "calculator.feature.powerDialer": "Power Dialer",
      "calculator.feature.missedCallsAutomation": "Missed calls automation",
      "calculator.feature.personalManager": "Dedicated Customer Success",
      "calculator.feature.prioritySupport": "Priority support",
      "calculator.feature.customReportsCrm": "Custom reports & integrations",

      // Tabs
      "tabs.newCalculation": "New calculation",
      "tabs.allCalculations": "All calculations",

      // Test Scenarios Dashboard
      "testScenarios.title": "Test Scenarios Dashboard",
      "testScenarios.subtitle": "Visualize and validate pricing scenarios",
      "testScenarios.info": "This dashboard shows all pricing test scenarios. Click \"Apply\" to create a new calculator tab with the scenario configuration.",
      "testScenarios.backToCalculator": "Back to Calculator",
      "testScenarios.total": "Total: {{count}}",
      "testScenarios.passed": "Passed: {{count}}",
      "testScenarios.failed": "Failed: {{count}}",
      "testScenarios.search": "Search",
      "testScenarios.searchPlaceholder": "Search by description...",
      "testScenarios.product": "Product",
      "testScenarios.tier": "Tier",
      "testScenarios.region": "Region",
      "testScenarios.status": "Status",
      "testScenarios.all": "All",
      "testScenarios.passedOnly": "Passed",
      "testScenarios.failedOnly": "Failed",
      "testScenarios.description": "Description",
      "testScenarios.quantity": "Qty",
      "testScenarios.expected": "Expected",
      "testScenarios.actual": "Actual",
      "testScenarios.actions": "Actions",
      "testScenarios.apply": "Apply",
      "testScenarios.testPassed": "Test passed",
      "testScenarios.testFailed": "Test failed",
      "testScenarios.noResults": "No scenarios match your filters",
      "testScenarios.noConfig": "No calculator config available for this scenario",
      "testScenarios.tabCreated": "Tab \"{{name}}\" created! Configure manually or check the scenario config.",
      "testScenarios.applyError": "Error creating tab",

      "admin.users": "Users",
      "admin.usersManagement": "Users Management",
      "admin.usersDescription": "Manage user roles and view activity",
      "admin.searchUsers": "Search by email or name...",
      "admin.showingUsers": "Showing {{showing}} of {{total}} users",
      "admin.name": "Name",
      "admin.email": "Email",
      "admin.role": "Role",
      "admin.actions": "Actions",
      "admin.loadingUsers": "Loading users...",
      "admin.noUsers": "No users found",
      "admin.adjustSearch": "Try adjusting your search",
      "admin.viewHistory": "View history",
      "admin.roleUpdated": "Role updated successfully",
      "admin.roleUpdateFailed": "Failed to update role",
      "admin.userHistory": "{{name}} — History",
      "admin.userHistoryShort": "User History",
      "admin.backToUsers": "Back to Users",
      "admin.selectedCount": "{{count}} selected",
      "admin.selectRole": "Select role...",
      "admin.applyRole": "Apply",
      "admin.clearSelection": "Clear selection",
      "admin.bulkSuccess": "Updated {{count}} users",
      "admin.bulkPartial": "Updated {{success}}, failed {{fail}}",

      "offer.heroTitle": "Offer for",
      "offer.yourProducts": "Your Products",
      "offer.subscriptionOptions": "Payment Options",
      "offer.oneTimePayments": "One-time Payments",
      "offer.includedOneTimeFees": "Included One-time Fees",
      "offer.addedToPlanBelow": "↓ Added to subscriptions below",
      "comparison.oneTimeAddedToTotal": "*Added to plan below",
      "offer.oneTimeTotal": "Total one-time",
      "offer.advantages": "Why Ringostat?",
      "offer.contactTitle": "Have questions about this offer?",
      "offer.contactSubtitle": "Contact your account manager directly",
      "offer.contactSubtitleNamed": "Contact {{name}} directly",
      "offer.callManager": "Call your expert",
      "offer.emailManager": "Email",
      "offer.salesRole": "Ringostat Expert",
      "offer.heroDescription": "Control every communication, never lose a single customer, and free your team from routine — with Ringostat, the AI-powered communication platform.",
      "offer.priceNote": "annual payment, excl. VAT",
      "comparison.heroDescription": "Choose the optimal solution for your business from the proposed options. Each offer is tailored to your needs.",
      "comparison.paymentOptionsHint": "Longer term — higher discount",
      "comparison.variants": "{{count}} options",
      "comparison.yourOptions": "Your Options",
      "comparison.products": "products",
      "comparison.perYear": "/yr",
      "comparison.product": "Product",
      "comparison.totalMonthly": "Total / month",
      "comparison.detailedComparison": "Detailed Comparison",
      "offer.viewFullOffer": "View Full Offer",
      "offer.comparePlans": "Compare Business Phone Plans",
      "offer.comparisonTitle": "Offer Comparison for {{client}}",
      "offer.included": "Included",
      "offer.annualPlan": "Annual plan",
      "offer.saveBadge": "Save {{percent}}%",
      "offer.recommended": "Recommended",
      "offer.perMonth": "/mo",
      "offer.toPay": "to pay",
      "offer.withVat": "With VAT 20%: {{amount}}",
      "offer.validUntil": "Valid until {{date}}",
      "offer.exportPDF": "Export PDF",
      "offer.oneTimePaymentHint": "One-time setup fee",
      "offer.perMonthLabel": "per month",
      "offer.acceptRecommendation": "Accept Recommendation",
      "offer.selectPlan": "Select Plan",
      "offer.saveBullet": "Save {{percent}}%",
      "offer.priceLocked": "Price locked for 12 months",
      "offer.dedicatedManager": "Dedicated success manager",
      "offer.subscriptionBadge": "{{days}}-day plan",
      "offer.perYear": "/year",
      "offer.totalAnnual": "Total: {{amount}}/year",
      "advantages.iso.title": "ISO 27001 Certified",
      "advantages.iso.desc": "Data protected by international security standards",
      "advantages.apps.title": "Cross-platform Apps",
      "advantages.apps.desc": "Native apps for iOS, Android, Windows, macOS. Using Ringostat is easy and convenient",
      "advantages.crm.title": "Most flexible integrations with 50+ CRMs",
      "advantages.crm.desc": "Seamless integration with Salesforce, HubSpot, Pipedrive, ZohoCRM & more. Fine-tuned to your business processes",
      "advantages.missed.title": "Customer loss prevention",
      "advantages.missed.desc": "Flexible call distribution, mobile apps, and the best missed call management interface on the market",
      "advantages.support.title": "Support you deserve",
      "advantages.support.desc": "95% of clients rate our support as \"Good\" or \"Excellent\". Average response time — 2 minutes",
      "advantages.recordings.title": "Unlimited call recordings",
      "advantages.recordings.desc": "Free unlimited storage of call recordings on all plans",
      "advantages.analytics.title": "Powerful analytics & reporting",
      "advantages.analytics.desc": "Real-time dashboards, custom reports & AI-powered insights for every call",
      "advantages.ukraine.title": "Crystal-clear call quality",
      "advantages.ukraine.desc": "Pure SIP without GSM gateways — high stability and excellent voice quality on every call",

      "profile.title": "Complete Your Profile",
      "profile.editTitle": "Edit Profile",
      "profile.firstName": "First Name",
      "profile.lastName": "Last Name",
      "profile.phone": "Corporate Phone",
      "profile.phoneExtension": "Extension",
      "profile.phoneExtensionHelper": "IVR extension code (2-6 digits)",
      "profile.uploadPhoto": "Upload Photo",
      "profile.changePhoto": "Change Photo",
      "profile.save": "Save",
      "profile.saving": "Saving...",
      "profile.cropTitle": "Crop Photo",
      "profile.cropConfirm": "Apply",
      "profile.cropCancel": "Cancel",
      "profile.menuItem": "My Profile",
      "profile.required": "This field is required",
      "profile.latinOnly": "Latin characters only",
      "profile.invalidPhone": "Phone must start with + and contain 7-15 digits",
      "profile.invalidExtension": "Extension must be 2-6 digits",
      "profile.photoRequired": "Please upload a profile photo",
      "profile.subtitle": "Please fill in your details to continue using the calculator",
      "profile.photoUploadRequired": "Upload your own photo",
      "profile.photoUploadExplanation": "Your Google avatar is shown as a placeholder but cannot be used. Click \"Upload Photo from your computer\" above and choose a file from your computer — that's the only way to enable the Save button.",
      "profile.phoneFormatHelper": "International format only, no spaces or symbols. Example: +48739109524",
      "profile.uploadPhotoFromComputer": "Upload Photo from your computer",
      "profile.saveFailed": "Could not save your profile. Please try again or contact support."
    }
  },
  ua: {
    translation: {
      "calculator.title": "Калькулятор вартості сервісів Ringostat",
      "calculator.monthlyCost": "Місячна вартість сервісів",
      "calculator.addProduct": "Додати продукт",
      "calculator.users": "Користувачі Бізнес-телефонії",
      "calculator.usersLabel": "Користувачі",
      "calculator.usersInputLabel": "Користувачів бізнес-телефонії",

      "calculator.sessions": "Сесій Колтрекінгу/день",
      "calculator.sessionsLabel": "Сесії",
      "calculator.sessionsInputLabel": "Сесій колтрекінгу",

      "calculator.total": "Сума",
      "calculator.totalPerMonth": "Сума на місяць",
      "calculator.generateOffer": "Згенерувати офер",
      "calculator.placeholderAdd": "Додайте хоча б один продукт для розрахунку вартості",
      "calculator.selectRegion": "Оберіть регіон",
      "calculator.callTracking": "Call Tracking",
      "calculator.businessPhone": "Business Phone",
      "calculator.ai": "Мовна аналітика ШІ",
      "calculator.callback": "Callback",
      "calculator.aiMinutesInputLabel": "Хвилин ШІ-аналітики",
      "calculator.callbackSessionsInputLabel": "Сесій Callback",
      "calculator.addProductsTitle": "Додати продукти",
      "calculator.selectedProductsTitle": "Обрані продукти",
      "calculator.phoneNumbers": "Номери телефонів",
      "calculator.addMore": "+ Додати ще",
      "calculator.allProductsSelected": "Ви обрали всі доступні продукти! 🎉",
      "calculator.addPhoneNumbers": "Додати номери телефонів",
      "calculator.editPhoneNumbers": "Редагувати номери телефонів",
      "calculator.quantity": "Кількість",
      "calculator.pricePerNumber": "Ціна за номер",
      "calculator.add": "Додати",
      "calculator.update": "Оновити",
      "calculator.estimatedTotal": "Орієнтовна сума",
      "calculator.offerPageTitle": "Комерційна пропозиція (демо)",
      "calculator.offerPageDesc": "Тут буде сторінка згенерованої комерційної пропозиції для клієнта з брендуванням Ringostat.",
      "calculator.summary": "Підсумок",
      "calculator.noItemsSelected": "Продукти не обрано",
      "calculator.addProducts": "Додати продукти",
      "calculator.voiceTraffic": "Пакети хвилин",
      "calculator.aiConversation": "Мовна аналітика з ШІ",
      "calculator.omnichannelChat": "Омніканальний чат",
      "calculator.voiceTrafficPackageUA": "Пакет хвилин UA",
      "calculator.voiceTrafficPackageKZ": "Пакет хвилин KZ",
      "calculator.voiceTrafficPackageTooltip": "Оберіть пакет вручну або дозвольте системі вибрати найбільш вигідний",
      "calculator.voiceTrafficSelectedPackages": "Обрані пакети",
      "calculator.voiceTrafficCustomAmount": "Сума на зв'язок",
      "calculator.voiceTrafficSettings": "Налаштування голосового трафіку",
      "calculator.voiceTrafficCountries": "Країни", 
      "calculator.voiceTrafficCountriesDescription": "Оберіть країни для пакетів голосового трафіку. Ви можете обрати кілька країн.",
      "calculator.voiceTrafficCustomAmountDescription": "Використовувати кастомну суму замість автоматичного вибору пакета",
      "calculator.voiceTrafficSummary": "Система автоматично обере найкращі пакети для {{count}} країн на основі ваших потреб у хвилинах.",
      "calculator.voiceTrafficSelectedCountries": "Обрані країни: {{countries}}",
      "calculator.voiceTrafficCustomAmountInput": "Депозит на зв'язок",
      "calculator.voiceTrafficPackageDetails": "{{includedMinutes}} хвилин включено",
      "calculator.voiceTrafficOverageMinutes": "додаткових хвилин",
      "calculator.voiceTrafficOverageText": "хв. зверх пакету",
      "calculator.voiceTrafficOverageShort": "поза пакетом",
      "calculator.voiceTrafficPerMinute": "грн/хв",
      "calculator.voiceTrafficCurrencyUAH": "грн/хв",
      "calculator.voiceTrafficCurrencyKZT": "тенге/хв",
      "calculator.voiceTrafficCurrencyPLN": "зл/хв",
      "calculator.voiceTrafficCurrencyEUR": "€/хв",
      "calculator.voiceTrafficVolumeUA": "Об'єм вихідного зв'язку в Україні",
      "calculator.voiceTrafficVolumeKZ": "Об'єм вихідного зв'язку в Казахстані",
      "calculator.voiceTrafficVolumePL": "Об'єм вихідного зв'язку в Польщі",
      "calculator.voiceTrafficMinutesShort": "хв.",
      "calculator.voiceTrafficMinutesUnit": "хвилин",
      "calculator.voiceTrafficPackage": "Пакет",
      "calculator.voiceTrafficMinutes": "хвилин",
      "countries.ukraine": "Україна",
      "countries.kazakhstan": "Казахстан", 
      "countries.poland": "Польща",
      "voicePackages.noPackagesHint": "Деякі країни недоступні — немає активних пакетів хвилин",
      "voicePackages.title": "Пакети хвилин",
      "voicePackages.subtitle": "Управління пакетами хвилин голосового трафіку",
      "voicePackages.addPackage": "Додати пакет",
      "voicePackages.editPackage": "Редагувати пакет",
      "voicePackages.showingEntries": "Показано {{showing}} з {{total}} записів",
      "voicePackages.confirmDelete": "Видалити пакет?",
      "voicePackages.confirmDeleteText": "Ви впевнені, що хочете видалити \"{{name}}\" ({{country}})?",
      "voicePackages.country": "Країна",
      "voicePackages.allCountries": "Всі",
      "voicePackages.searchPlaceholder": "Пошук за назвою...",
      "voicePackages.name": "Назва",
      "voicePackages.minutes": "Хвилини",
      "voicePackages.priceLocal": "Ціна локальна",
      "voicePackages.currency": "Валюта",
      "voicePackages.priceUsd": "Ціна USD",
      "voicePackages.perMinLocal": "За хв. лок.",
      "voicePackages.perMinUsd": "За хв. USD",
      "voicePackages.overageLocal": "Наднорма лок.",
      "voicePackages.overageUsd": "Наднорма USD",
      "voicePackages.active": "Активний",
      "voicePackages.actions": "Дії",
      "voicePackages.edit": "Редагувати",
      "voicePackages.delete": "Видалити",
      "voicePackages.loading": "Завантаження пакетів...",
      "voicePackages.noEntries": "Пакетів не знайдено",
      "voicePackages.adjustFilters": "Спробуйте змінити фільтри",
      "voicePackages.pricePerMinuteLocal": "Ціна за хвилину",
      "voicePackages.overageRateLocal": "Тариф наднорми",
      "voicePackages.isActive": "Активний",
      "voicePackages.usdInfo": "USD ціни оновлюються автоматично щоденним cron завданням",
      "voicePackages.fetchError": "Не вдалося завантажити пакети",
      "voicePackages.updated": "Пакет оновлено",
      "voicePackages.created": "Пакет створено",
      "voicePackages.deleted": "Пакет видалено",
      "voicePackages.deleteError": "Не вдалося видалити пакет",
      "voicePackages.toggleError": "Не вдалося змінити статус",
      "calculator.minute": "хвилина",
      "calculator.pricePerMinute": "Ціна за хвилину",
      "calculator.totalPrice": "Загальна ціна",
      "calculator.customSettingsEnabled": "Користувацькі налаштування увімкнено",
      "calculator.aiSettingsTitle": "Налаштування мовної аналітики з ШІ",
      "calculator.enableNonEnglishAnalysis": "Увімкнути аналіз неанглійської мови",
      "calculator.nonEnglishAnalysisTooltip": "Уніфіковане ціноутворення: $0.03 за хвилину для всіх регіонів (окрім Європи: €0.03)",
      "calculator.resetToDefault": "Скинути",
      "calculator.apply": "Застосувати",
      "calculator.cancel": "Скасувати",
      "calculator.pricingInformation": "Інформація про ціни:",
      "calculator.standardAnalysis": "Стандартний аналіз:",
      "calculator.nonEnglishAnalysis": "Аналіз неанглійської мови:",
      "calculator.monthlyTotal": "Вартість на місяць",
      "calculator.paymentOptions": "Варіанти оплати",
      "calculator.paymentSummary": "Підсумок оплати",
      "calculator.standardPlan": "360 днів",
      "calculator.bestValue": "Найкраща ціна - ",
      "calculator.sixMonthPlan": "Підписка на 180 днів",
      "calculator.threeMonthMinimum": "Підписка на 90 днів",
      "calculator.monthlyContract": "12-місячний контракт",
      "calculator.splitPayment": "Підписка на 360 днів (оплата частинами)",
      "calculator.moreExpensivePerYear": "дорожче на рік",
      "calculator.businessPhoneUsers": "користувачів",
      "calculator.fmcUsers": "користувачів",
      "calculator.advancedDiscountSettings": "Розширені налаштування знижок",
      "calculator.discount360Days": "Знижка 360 днів",
      "calculator.discount180Days": "Знижка 180 днів",
      "calculator.advancedDiscountHint": "Натисніть Cmd+Shift+D (Mac) або Ctrl+Shift+D (PC) щоб приховати",
      "calculator.businessPhoneUsersLabel": "Кількість користувачів бізнес-телефонії",
      "calculator.businessPhoneUsersLabelStandalone": "Кількість користувачів",
      "calculator.fmcUsersLabel": "Кількість FMC користувачів",
      "calculator.fmcUsersLabelStandalone": "Кількість користувачів",
      "calculator.callTrackingSlots": "слотів",
      "calculator.aiMinutes": "хвилин",
      "calculator.callbackSessions": "сесій",
      "calculator.phoneNumbersCount": "номерів",
      "calculator.businessPhoneLabel": "Business Phone",
      "calculator.fmcLabel": "FMC", 
      "calculator.callTrackingLabel": "Call Tracking",
      "calculator.aiConversationLabel": "Мовна аналітика з ШІ",
      "calculator.callbackLabel": "Callback",
      "calculator.voiceTrafficLabel": "Пакет хвилин",
      "calculator.chatUsers": "користувачів",
      "calculator.chatUsersLabel": "Кількість користувачів",
      "calculator.businessPhoneDesc": "Кількість користувачів, які потребують Business Phone",
      "calculator.callTrackingDesc": "Сесії веб-сайту на день",
      "calculator.aiConversationDesc": "Кількість хвилин для аналізу на місяць",
      "calculator.callbackDesc": "Орієнтовна кількість запитів на Callback на місяць",
      "calculator.phoneNumbersDesc": "Купівля та управління номерами телефонів",
      "calculator.voiceTrafficDesc": "Кількість хвилин голосового трафіку на місяць",
      "calculator.omnichannelChatDesc": "Користувачі для онлайн чату + месенджери (Viber, Telegram, Facebook)",
      "calculator.betaProduct": "BETA -50%",
      "calculator.betaPricing": "Бета-ціна: знижка 50% застосована",
      "calculator.omnichannelChatWarning": "Омніканальний чат потребує спочатку додати Business Phone.",
      "calculator.omnichannelChatWarning.title": "Вимоги до продукту",
      "calculator.omnichannelChatFmcInfo": "Omnichannel Chat доступний лише з Business Phone. При FMC редагування недоступне.",
      "calculator.omnichannelChatLimitInfoWithValue": "Максимум для чату — {{max}} (дорівнює кількості користувачів Business Phone). Щоб вказати більше в інпуті, спочатку збільште Business Phone.",
      "common.ok": "ОК",
      "calculator.businessPhoneSettings": "Налаштування Business Phone",
      "calculator.businessPhoneType": "Тип Business Phone",
      "calculator.businessPhoneOnly": "Business Phone",
      "calculator.fmcOnly": "FMC",
      "calculator.businessPhoneFmc": "Business Phone + FMC",
      "calculator.businessPhonePricing": "Business Phone: €20 за користувача",
      "calculator.fmcPricing": "FMC: $5 за користувача",
      "calculator.comparePlans": "Порівняти",
      "calculator.compareFeatures": "Порівняти функції",
      "calculator.comparePlansTitle": "Порівняння тарифів",
      "calculator.feature": "Функція",
      "calculator.selected": "Вибрано",
      "calculator.compareTip": "Натисніть на колонку тарифу щоб вибрати його",
      "calculator.included": "ВКЛЮЧЕНО",
      "calculator.includedInTier": "Включено в тариф {{tier}}",
      "calculator.includedInProCorporate": "Включено в Pro/Corporate",
      "calculator.perUser": "/користувач",
      "calculator.comingSoon": "Скоро",
      "calculator.uaBusinessDiscount": "Знижка для українського бізнесу",
      "calculator.features.aiConversation": "Мовна аналітика (AI)",
      "calculator.features.aiConversationBasicLevel": "Базовий",
      "calculator.features.aiConversationProLevel": "Професійний Eniq AI",
      "calculator.features.omnichannelChat": "Омніканальний чат",
      "calculator.features.callback": "Callback",
      "calculator.features.realTimeReports": "Звіти в реальному часі",
      "calculator.features.agentStatuses": "Статуси співробітників",
      "calculator.features.callWhisper": "Режим суфлера",
      "calculator.features.csat": "CSAT",
      "calculator.features.customerSuccessTeam": "Customer Success",
      "calculator.features.powerDialer": "Power Dialer",
      "calculator.features.autoMissedProcessing": "Автоматизація пропущених",
      "calculator.features.prioritySupport": "Пріоритетна підтримка",
      "calculator.features.dedicatedVipCs": "VIP Customer Success",
      "calculator.features.customLookerReports": "Кастомні звіти Looker",
      "calculator.features.customUserRoles": "Гнучкі налаштування ролей",
      "calculator.features.customCrmIntegration": "Кастомна CRM інтеграція",
      "calculator.eniqCompare.title": "Порівняння тарифів Eniq AI",
      "calculator.eniqCompare.note": "Ціна вказана за одного користувача на місяць",
      "calculator.eniqCompare.models": "AI-моделі",
      "calculator.eniqCompare.modelsStandard": "Стандартні моделі",
      "calculator.eniqCompare.modelsPro": "Premium моделі",
      "calculator.eniqCompare.promptLimit": "Довжина промпту аналізу",
      "calculator.eniqCompare.promptLimitStandard": "До 30k символів",
      "calculator.eniqCompare.promptLimitPro": "Без обмежень",
      "calculator.eniqCompare.insights": "AI Insights",
      "calculator.eniqCompare.insightsStandard": "Стандартні ліміти",
      "calculator.eniqCompare.insightsPro": "Розширені ліміти",
      "calculator.eniqCompare.knowledgeBase": "База знань",
      "calculator.eniqCompare.knowledgeBaseStandard": "Стандартні ліміти",
      "calculator.eniqCompare.knowledgeBasePro": "Розширені ліміти",
      "calculator.eniqCompare.training": "AI Тренінг",
      "calculator.eniqCompare.trainingStandard": "1 година на користувача",
      "calculator.eniqCompare.trainingPro": "Розширений ліміт",
      "calculator.eniqTierLabel": "Тариф Eniq AI",
      "calculator.eniqTierStandard": "Standard",
      "calculator.eniqTierPro": "Pro",
      "calculator.eniqUsersLabel": "Кількість користувачів",
      "calculator.eniqUsersLinkedInfo": "Кількість користувачів Eniq AI прив'язана до Business Phone/FMC",
      "calculator.eniqUpgradeDiff": "Standard уже входить у Corporate — доплачуєте лише різницю",
      "calculator.eniqMinBillableUsers": "Eniq AI завжди тарифікується мінімум за {{count}} користувачів",
      "calculator.fmcRegionWarning.title": "Попередження про зміну регіону",
      "calculator.fmcRegionWarning.message": "Ви переходите на регіон, де продукт FMC не підтримується. FMC буде видалено з вашого вибору. Бажаєте продовжити?",
      "calculator.fmcRegionWarning.confirm": "Змінити регіон",
      "common.cancel": "Скасувати",
      "common.reset": "Скинути",
      "common.apply": "Застосувати",
      "common.save": "Зберегти",
      "common.create": "Створити",
      "common.delete": "Видалити",
      "calculator.callTrackingSettings": "Налаштування Call Tracking",
      "calculator.trackingType": "Тип трекінгу",
      "calculator.dynamicTracking": "Динамічний (на основі сесій)",
      "calculator.staticTracking": "Статичний (фіксовані джерела)",
      "calculator.combinedTracking": "Комбінований (динамічний + статичний)",
      "calculator.enableCallMeButton": "Увімкнути кнопку \"Call me\"",
      "calculator.numberFormatsQuantity": "Кількість форматів номерів",
      "calculator.globalSettings": "Глобальні налаштування",
      "calculator.globalSettingsPlaceholder": "Глобальні налаштування будуть доступні тут",
      "calculator.showAdvancedTier": "Показати тариф Advanced",
      "calculator.showAdvancedTierDescription": "Увімкнути прихований тариф Advanced для Бізнес Телефону (UA, Central Asia, Other регіони)",
      "calculator.showPricesWithoutBonuses": "Показувати ціни без довгострокових бонусів",
      "calculator.showPricesWithoutBonusesDescription": "Прогноз щомісячної плати показуватиме ціни без знижки за 360-денну передплату",
      "calculator.subscriptionOptions": "Опції підписки",
      "calculator.subscription12Month": "12-місячний контракт",
      "calculator.subscriptionSplitPayment": "Оплата частинами",
      "calculator.legacyOptions": "Legacy Options",
      "calculator.subscription90Days": "Підписка на 90 днів",
      "calculator.subscription180Days": "Підписка на 180 днів",
      "calculator.phoneNumberName": "Назва номера телефону",
      "calculator.unitPrice": "Ціна",
      "calculator.noPhoneNumbers": "Номери телефонів ще не додано. Натисніть \"Додати номеру\", щоб додати.",
      "calculator.addPhoneNumber": "Додати номер",
      "calculator.addFromCatalog": "Додати з каталогу",
      "calculator.phoneCatalog": "Каталог номерів",
      "calculator.addToOffer": "Додати в пропозицію",
      "calculator.itemsSelected": "{{count}} обрано",
      "calculator.fromPrice": "ВІД",
      "calculator.fromPriceHint": "Ціна починається від цієї суми",
      "calculator.noResults": "Номери не знайдено",
      "calculator.fromCatalog": "З каталогу",
      "calculator.phoneNamePlaceholder": "Введіть для пошуку в каталозі...",
      "calculator.selectCountry": "Країна",
      "calculator.selectCity": "Місто",
      "calculator.selectProvider": "Провайдер",
      "calculator.searchNumbers": "Пошук...",
      "calculator.monthlyFee": "Абонплата",
      "calculator.country": "Країна",
      "calculator.city": "Місто",
      "calculator.provider": "Провайдер",
      "calculator.code": "Код",
      "calculator.currency": "Вал.",
      "calculator.docsShort": "Док.",
      "calculator.commentShort": "Прим.",
      "calculator.requiredDocs": "Необхідні документи",
      "calculator.commentTitle": "Коментар",
      "calculator.freeForTrial": "Тріал",
      "calculator.freeForTrialYes": "Безкоштовно на тріал",
      "calculator.docsRequired": "Потрібні документи",
      "admin.syncDIDWW": "Синхр. DIDWW Docs",
      "admin.syncDIDWWSyncing": "Синхронізація...",
      "admin.syncDIDWWSuccess": "Синхронізовано {{countries}} країн, оновлено {{entries}} записів",
      "admin.syncDIDWWError": "Не вдалось синхронізувати вимоги DIDWW",
      "admin.syncDIDWWStarted": "Синхронізація DIDWW запущена, зачекайте...",
      "admin.syncDIDWWAlreadyRunning": "Синхронізація вже виконується",
      "calculator.pleaseEnterName": "Будь ласка, введіть назву для номера телефону",
      "calculator.allProductsAdded": "Всі доступні продукти додано",
      "calculator.dailyWebsiteSessions": "Сесій на день (веб-сайт)",
      "calculator.staticSourcesDescription": "Кількість статичних джерел",
      "calculator.minutesToAnalyze": "Кількість хвилин для аналізу на місяць",
      "calculator.aiUsersLabel": "Кількість користувачів",
      "calculator.aiUsersLinkedInfo": "Кількість користувачів ШІ прив'язана до кількості користувачів Business Phone/FMC",
      "calculator.chatUsersLinkedInfo": "Кількість користувачів чату прив'язана до кількості користувачів Business Phone (FMC-користувачі не можуть користуватись чатом)",
      "calculator.phoneNumbersRequired": "Потрібно номерів телефонів",
      "calculator.minutes": "хвилин",
      "calculator.numbers": "номерів",
      "Settings": "Налаштування",
      "Region": "Регіон",
      "Initial Data": "Початкові дані",
      "Service Cost": "Вартість послуг",
      "Business Phone": "Business Phone",
      "Call Tracking": "Call Tracking",
      "Total": "Всього",
      "offers.notIncluded": "Не включено",
      "offers.included": "Включено",
      "offers.perMonth": "/міс",
      "offers.backToCalculator": "Назад до калькулятора",
      "offers.offerDetails": "Деталі пропозиції",
      "offers.comparisonCount": "Порівняння ({{count}}/5)",
      "offers.offersComparison": "Порівняння пропозицій",
      "offers.offersComparisonFor": "Порівняння пропозицій для {{companyName}}",
      "offers.proposalFor": "Пропозиція '{{offerName}}' для {{companyName}}",
      "offers.proposalForCompany": "Пропозиція для {{companyName}}",
      "offers.proposalDetails": "Пропозиція '{{offerName}}'",
      "offers.reviewOfferDetails": "Переглядайте деталі вашої пропозиції та оберіть тарифний план",
      "offers.currencyDisclaimer": "Вартість формується в доларах, оплата в гривнях по актуальному курсу на день оплати",
      "comparison.noCompanyName": "Не вказано назву компанії",
      "offers.compareOffersDescription": "Порівняйте різні пропозиції та оберіть найкращу для вашого бізнесу",
      "offers.offer": "Пропозиція",
      "offers.productsAndUsage": "Продукти та використання",
      "offers.subscriptionOptions": "Варіанти підписки",
      "offers.available": "Доступно",
      "offers.exportToPDF": "Експорт в PDF",
      "offers.validUntil": "Дійсна до {{date}}",
      "offers.validUntilShort": "дійсно до",
      "offers.validityPeriod": "14 днів з дати генерації",
      "offers.notAvailable": "Недоступно",
      "offers.toPay": "до сплати",
      "offers.savePerYear": "економія",
      "offers.perYear": "на рік",
      "offers.plan360days20": "360 днів (бонус 20%)",
      "offers.savings": "Економія",
      "offers.annualPayment": "річна оплата",
      "offers.plan360daysNoBonus": "360 днів (без бонусу)",
      "offers.plan180days": "180 днів (бонус 10%)",
      "offers.plan90days": "90 днів",
      "offers.plan12month": "12-місячний контракт",
      "offers.plan360split": "360 днів (оплата частинами)",
      "offers.semiAnnualPayment": "за 6 місяців",
      "offers.detailedOffer": "Детальна пропозиція",
      "offers.removeFromComparison": "Видалити з порівняння",
      "offers.noOffersToCompare": "Немає пропозицій для порівняння",
      "offers.returnToCalculatorToCreate": "Поверніться до калькулятора щоб створити нові пропозиції",
      "calculator.aiConversationCalls": "дзвінків",
      "common.backToCalculator": "Назад до калькулятора",
      "history.title": "Історія пропозицій",
      "history.description": "Переглядайте та керуйте всіма вашими згенерованими пропозиціями та порівняннями",
      "history.dateTime": "Дата та час",
      "history.type": "Тип",
      "history.userEmail": "Email користувача",
      "history.link": "Посилання",
      "history.offer": "Пропозиція",
      "history.comparison": "Порівняння",
      "history.noHistory": "Поки немає порівнянь",
      "history.createFirst": "Створіть ваше перше порівняння в калькуляторі",
      "history.openInNewTab": "Відкрити в новій вкладці",
      "history.copyLink": "Скопіювати посилання",
      "history.useAsTemplate": "Використати як шаблон",
      "history.templateUnavailable": "Дані шаблону недоступні",
      "history.copied": "Скопійовано!",
      "history.offers": "пропозицій",
      "history.offersInComparison": "Пропозиції в цьому порівнянні",
      "history.clientName": "Назва компанії",
      "history.searchByClientName": "Пошук за назвою компанії...",
      "history.noClientName": "Немає назви компанії",
      "history.filters": "Фільтри",
      "history.selectDateRange": "Оберіть діапазон дат",
      
      // Додаткові переклади для offers
      "offers.generateOffer": "Згенерувати пропозицію",
      "offers.selectTabsDescription": "Оберіть конфігурації цін, які ви хочете включити до своєї пропозиції:",
      "offers.selectAll": "Обрати все",
      "offers.configuration": "Конфігурація",
      "offers.generateComparison": "Згенерувати порівняння",
      "offers.offerGenerated": "Пропозицію створено!",
      "offers.offerGeneratedDescription": "Ваша цінова пропозиція була успішно створена",
      "offers.offerLink": "Посилання на пропозицію:",
      "offers.offerShareInfo": "Поділіться цим посиланням з клієнтами, щоб показати їм детальну цінову пропозицію.",
      "offers.comparisonGenerated": "Порівняння згенеровано!",
      "offers.comparisonGeneratedDescription": "Ваше цінове порівняння успішно створене",
      "offers.comparisonLink": "Посилання на порівняння:",
      "offers.comparisonShareInfo": "Поділіться цим посиланням з клієнтами, щоб показати їм порівняння різних цінових опцій.",
      "offers.copyLink": "Копіювати посилання",
      "offers.openInNewTab": "Відкрити в новій вкладці",
      "offers.linkCopied": "Посилання скопійовано в буфер обміну!",
      "offers.yourProposal": "Ваша пропозиція",
      "offers.monthlyForecast": "Прогнозована вартість на місяць",
      "offers.chooseThisPlan": "Обрати цей план",
      "offers.monthlyCost": "Щомісячна вартість",
      "calculator.monthlyForecast": "Прогнозована вартість на місяць",
      "offers.clientName": "Назва компанії *",
      "offers.clientNamePlaceholder": "Введіть назву компанії...",
      "offers.clientNameRequired": "Назва компанії є обов'язковою",
      "offers.generating": "Генерація...",
      "offers.noTabsAvailable": "Немає доступних конфігурацій цін",
      
      // Додаткові переклади для common
      "common.close": "Закрити",

      // Переклади для сторінки логіну
      "login.title": "Логін в калькулятор цін Ringostat",
      "login.welcome": "Використовуй свій корпоративний Google аккаунт (@ringostat.com)",
      "login.continueWithGoogle": "Продовжити через Google",

      // Переклади для підписок
      "subscription.360Days": "360 днів (бонус 20%)",
      "subscription.360DaysCustom": "360 днів (бонус {{discount}}%)",
      "subscription.360DaysNoBonus": "360 днів",
      "subscription.180Days": "180 днів",
      "subscription.180DaysCustom": "180 днів (бонус {{discount}}%)",
      "subscription.90Days": "90 днів",
      "subscription.12MonthContract": "12-місячний контракт",
      "subscription.360DaysSplit": "360 днів (оплата частинами)",
      "subscription.toPay": "до сплати",
      "subscription.savings": "економія",
      "subscription.perYear": "на рік",
      "subscription.perMonth": "/міс",
      "subscription.days": "днів",
      "subscription.bonus": "бонус",
      "subscription.splitPayment": "оплата частинами",
      "subscription.vatIncluded": "З ПДВ 20%: {{amount}}",
      
      // Переклади для валютного селектора
      "currency.display": "Валюта",
      "currency.uahNote": "Вартість формується в доларах, оплата в гривнях по актуальному курсу на день оплати.",
      "currency.uah": "грн",
      "currency.uahSymbol": "грн",
      "currency.usd": "USD",
      "currency.eur": "EUR",
      
      // Короткий переклад для періоду
      "calculator.perMonthShort": "/місяць",
      
      // Одноразові платежі
      "calculator.oneTimePayments": "Одноразові платежі",
      "calculator.phoneNumberActivation": "Активація номерів",
      "calculator.eniqImplementationFee": "Впровадження Eniq AI",
      "calculator.enableImplementationFee": "Плата за впровадження",
      "calculator.implementationFeeDescription": "Одноразова плата за впровадження та налаштування Eniq AI",
      "calculator.implementationFeeAmount": "Сума впровадження",
      
      // Phone Numbers Settings
      "calculator.phoneNumbersSettings": "Налаштування номерів телефонів",
      "calculator.enablePhoneActivation": "Увімкнути вартість активації",
      "calculator.activationFee": "Активація",
      "calculator.activationTotal": "Вартість активації",
      
      // Date Picker
      "datePicker.today": "Сьогодні",
      "datePicker.yesterday": "Вчора",
      "datePicker.last7Days": "Останні 7 днів",
      "datePicker.last30Days": "Останні 30 днів",
      "datePicker.currentMonth": "Поточний місяць",
      "datePicker.previousMonth": "Попередній місяць",
      "datePicker.selectDateRange": "Оберіть діапазон дат",
      "datePicker.quickSelect": "Швидкий вибір",
      "datePicker.customRange": "Кастомний діапазон",
      "datePicker.from": "Від",
      "datePicker.to": "До",
      "datePicker.clear": "Очистити",
      
      // Переклади для Eniq AI
      "calculator.eniqAiLabel": "Eniq AI",
      "calculator.eniqAiDesc": "AI-powered conversation analysis",
      "calculator.eniqAiMinutes": "хвилин",
      "calculator.eniqAiMinutesInput": "Кількість хвилин",
      "calculator.eniqAiUnits": "юнітів",
      "calculator.eniqAiPremiumModels": "Преміум моделі",
      "calculator.eniqAiSettings": "Налаштування Eniq AI",
      "calculator.eniqAiAnalysisType": "Тип аналізу",
      "calculator.eniqAiPremiumDescription": "Аналіз високої точності з просунутими ШІ моделями (1 кредит на хвилину)",
      "calculator.eniqAiStandardNote": "Стандартні моделі",
      "calculator.eniqAiStandardDescription": "Економний аналіз зі стандартними ШІ моделями (0.33 кредита на хвилину)",
      "calculator.eniqAiDescription": "ШІ-аналіз розмов з гнучкими тарифними планами залежно від ваших потреб.",
      "calculator.eniqAiOptimalPlan": "Оптимальний план",
      "calculator.eniqAiIncluded": "хвилин включено",
      "calculator.eniqAiExtraMinutes": "додаткових хвилин",
      "calculator.eniqAiUnitsIncluded": "юнітів включено",
      "calculator.eniqAiExtraUnits": "додаткових юнітів",
      "calculator.eniqAiTariff": "Тариф",
      // Advanced Settings
      "calculator.advancedSettings": "Розширені налаштування",
      "calculator.veryCustomProductDiscount": "Кастомна знижка продукту",
      "calculator.customDiscountNote": "Застосовується після bundled знижок (0-100%)",
      "calculator.advancedSettingsHint": "Доступ: Подвійний клік на заголовок або Ctrl+Shift+C",
      "calculator.omnichannelChatSettings": "Налаштування Омніканального чату",
      "calculator.omnichannelChatSettingsDescription": "Наразі немає додаткових налаштувань для Омніканального чату.",
      "calculator.eniqAiCalculationError": "Не вдалося розрахувати ціну",
      "calculator.calculating": "Розрахунок...",
      
      // Eniq AI Plan Names (keep in English)
      "calculator.eniqAiPlanStart": "Start",
      "calculator.eniqAiPlanPro": "Pro",
      "calculator.eniqAiPlanMax": "Max",
      "calculator.eniqAiPlanScale": "Scale",

      // VoiceBot
      "calculator.voicebotLabel": "Голосовий бот",
      "calculator.voicebotDesc": "Автоматичні дзвінки на базі ШІ",
      "calculator.voicebotMinutesInput": "Кількість хвилин",
      "calculator.voicebotMinutesUnit": "хв",
      "calculator.voicebotSettings": "Налаштування VoiceBot",
      "calculator.voicebotMode": "Режим кампанії",
      "calculator.voicebotAiMode": "AI VoiceBot",
      "calculator.voicebotAiDescription": "ШІ-розмови (1000 юнітів за хвилину)",
      "calculator.voicebotRoboCallMode": "RoboCall",
      "calculator.voicebotRoboCallDescription": "Автоматичні дзвінки без ШІ (100 юнітів за хвилину)",
      "calculator.voicebotExtraChannels": "Додаткові робо-канали",
      "calculator.voicebotChannelsIncluded": "3 канали включено в кожен план",
      "calculator.voicebotExtraChannelsCount": "Додаткові канали",
      "calculator.voicebotChannelPrice": "$25/міс за канал",
      "calculator.voicebotTotalChannels": "всього каналів",
      "calculator.voicebotPerMonth": "міс",
      "calculator.voicebotImplementationFee": "Плата за впровадження",
      "calculator.voicebotImplementationFeeLabel": "Впровадження VoiceBot",
      "calculator.voicebotImplementationFeeDesc": "Одноразова оплата за впровадження та налаштування VoiceBot",
      "calculator.voicebotMinIncluded": "хв включено",
      "calculator.voicebotExtraMin": "додаткових хв",
      "calculator.planLite": "Lite",
      "calculator.tariff": "Тариф",

      // Selected Plan Features
      "calculator.selectedPlanIncludes": "Обраний план включає",

      // Basic tier features
      "calculator.feature.mobileDesktopApps": "Декстоп та мобільні застосунки",
      "calculator.feature.callRecordingUnlimited": "Безлімітний запис дзвінків",
      "calculator.feature.integrations50": "50+ готових інтеграцій",
      "calculator.feature.reportsControlMissed": "Потужні звіти та статистика",
      "calculator.feature.flexibleRouting": "Гнучка маршрутизація",
      "calculator.feature.ivrVoicemail": "IVR, голосова пошта",

      // Pro tier features
      "calculator.feature.allBasicFeatures": "Усі функції тарифу Basic",
      "calculator.feature.callTranscription": "Транскрипція дзвінків",
      "calculator.feature.aiQualityScoring": "Оцінка якості дзвінків (AI)",
      "calculator.feature.omnichannelMessengers": "Чат та месенджери",
      "calculator.feature.callbackWidget": "Віджет callback",
      "calculator.feature.advancedReportsSchedule": "Розширені звіти",

      // Corporate tier features
      "calculator.feature.allProFeatures": "Усі функції тарифу Pro",
      "calculator.feature.advancedConversationAnalytics": "Розширена мовна аналітика",
      "calculator.feature.powerDialer": "Power Dialer",
      "calculator.feature.missedCallsAutomation": "Автообробка пропущених",
      "calculator.feature.personalManager": "Персональний менеджер",
      "calculator.feature.prioritySupport": "Пріоритетна підтримка",
      "calculator.feature.customReportsCrm": "Кастомні звіти та інтеграції",

      // Tabs
      "tabs.newCalculation": "Новий розрахунок",
      "tabs.allCalculations": "Всі розрахунки",

      // Test Scenarios Dashboard
      "testScenarios.title": "Панель тестових сценаріїв",
      "testScenarios.subtitle": "Візуалізація та перевірка сценаріїв ціноутворення",
      "testScenarios.info": "Ця панель показує всі тестові сценарії ціноутворення. Натисніть \"Застосувати\" щоб створити нову вкладку калькулятора з конфігурацією сценарію.",
      "testScenarios.backToCalculator": "Назад до калькулятора",
      "testScenarios.total": "Всього: {{count}}",
      "testScenarios.passed": "Пройдено: {{count}}",
      "testScenarios.failed": "Не пройдено: {{count}}",
      "testScenarios.search": "Пошук",
      "testScenarios.searchPlaceholder": "Пошук за описом...",
      "testScenarios.product": "Продукт",
      "testScenarios.tier": "Тариф",
      "testScenarios.region": "Регіон",
      "testScenarios.status": "Статус",
      "testScenarios.all": "Всі",
      "testScenarios.passedOnly": "Пройдені",
      "testScenarios.failedOnly": "Не пройдені",
      "testScenarios.description": "Опис",
      "testScenarios.quantity": "Кількість",
      "testScenarios.expected": "Очікувано",
      "testScenarios.actual": "Фактично",
      "testScenarios.actions": "Дії",
      "testScenarios.apply": "Застосувати",
      "testScenarios.testPassed": "Тест пройдено",
      "testScenarios.testFailed": "Тест не пройдено",
      "testScenarios.noResults": "Немає сценаріїв за вашими фільтрами",
      "testScenarios.noConfig": "Для цього сценарію немає конфігурації калькулятора",
      "testScenarios.tabCreated": "Вкладку \"{{name}}\" створено! Налаштуйте вручну або перевірте конфігурацію сценарію.",
      "testScenarios.applyError": "Помилка створення вкладки",

      "admin.users": "Користувачі",
      "admin.usersManagement": "Управління користувачами",
      "admin.usersDescription": "Керуйте ролями користувачів та переглядайте активність",
      "admin.searchUsers": "Пошук за email або ім'ям...",
      "admin.showingUsers": "Показано {{showing}} з {{total}} користувачів",
      "admin.name": "Ім'я",
      "admin.email": "Email",
      "admin.role": "Роль",
      "admin.actions": "Дії",
      "admin.loadingUsers": "Завантаження користувачів...",
      "admin.noUsers": "Користувачів не знайдено",
      "admin.adjustSearch": "Спробуйте змінити пошуковий запит",
      "admin.viewHistory": "Переглянути історію",
      "admin.roleUpdated": "Роль успішно оновлено",
      "admin.roleUpdateFailed": "Не вдалося оновити роль",
      "admin.userHistory": "{{name}} — Історія",
      "admin.userHistoryShort": "Історія користувача",
      "admin.backToUsers": "Назад до користувачів",
      "admin.selectedCount": "{{count}} обрано",
      "admin.selectRole": "Оберіть роль...",
      "admin.applyRole": "Застосувати",
      "admin.clearSelection": "Скинути вибір",
      "admin.bulkSuccess": "Оновлено {{count}} користувачів",
      "admin.bulkPartial": "Оновлено {{success}}, помилок {{fail}}",

      "offer.heroTitle": "Пропозиція для",
      "offer.yourProducts": "Ваші продукти",
      "offer.subscriptionOptions": "Варіанти оплати",
      "offer.oneTimePayments": "Одноразові платежі",
      "offer.includedOneTimeFees": "Включені одноразові платежі",
      "offer.addedToPlanBelow": "↓ Включено в підписки нижче",
      "comparison.oneTimeAddedToTotal": "*Включено в підписку",
      "offer.oneTimeTotal": "Разом одноразово",
      "offer.advantages": "Чому Ringostat?",
      "offer.contactTitle": "Маєте питання щодо цієї пропозиції?",
      "offer.contactSubtitle": "Зверніться до вашого менеджера напряму",
      "offer.contactSubtitleNamed": "Зверніться до {{name}} напряму",
      "offer.callManager": "Подзвонити вашому експерту",
      "offer.emailManager": "Написати",
      "offer.salesRole": "Експерт Ringostat",
      "offer.viewFullOffer": "Детальна пропозиція",
      "offer.heroDescription": "Контролюйте кожну комунікацію, не втрачайте жодного клієнта та звільніть команду від рутини — з AI-платформою для комунікацій Ringostat.",
      "offer.priceNote": "при оплаті на рік, без ПДВ",
      "comparison.heroDescription": "Оберіть оптимальне рішення для вашого бізнесу серед запропонованих варіантів. Кожна пропозиція підібрана під ваші потреби.",
      "comparison.paymentOptionsHint": "Довший термін — вища знижка",
      "comparison.variants": "{{count}} варіанти",
      "comparison.yourOptions": "Ваші варіанти",
      "comparison.products": "продуктів",
      "comparison.perYear": "/рік",
      "comparison.product": "Продукт",
      "comparison.totalMonthly": "Всього / міс",
      "comparison.detailedComparison": "Детальне порівняння",
      "offer.comparePlans": "Порівняння тарифів Business Phone",
      "offer.comparisonTitle": "Порівняння пропозицій для {{client}}",
      "offer.included": "Включено",
      "offer.annualPlan": "Річний план",
      "offer.saveBadge": "Економія {{percent}}%",
      "offer.recommended": "Рекомендовано",
      "offer.perMonth": "/міс",
      "offer.validUntil": "Дійсна до {{date}}",
      "offer.perYear": "/рік",
      "offer.toPay": "до сплати",
      "offer.withVat": "З ПДВ 20%: {{amount}}",
      "offer.exportPDF": "Експорт PDF",
      "offer.oneTimePaymentHint": "Одноразова плата за підключення",
      "offer.perMonthLabel": "на місяць",
      "offer.acceptRecommendation": "Прийняти рекомендацію",
      "offer.selectPlan": "Обрати план",
      "offer.saveBullet": "Економія {{percent}}%",
      "offer.priceLocked": "Ціна зафіксована на 12 місяців",
      "offer.dedicatedManager": "Виділений менеджер",
      "offer.subscriptionBadge": "{{days}}-денний план",
      "offer.totalAnnual": "Разом: {{amount}}/рік",
      "advantages.iso.title": "Сертифікат ISO 27001",
      "advantages.iso.desc": "Дані захищені міжнародними стандартами безпеки",
      "advantages.apps.title": "Кросплатформові застосунки",
      "advantages.apps.desc": "Нативні застосунки для iOS, Android, Windows, macOS. Користуватись Ringostat легко та зручно",
      "advantages.crm.title": "Найгнучкіші інтеграції з 50+ CRM",
      "advantages.crm.desc": "Безшовна інтеграція з Salesforce, HubSpot, Pipedrive, ZohoCRM та іншими. Тонке налаштування під ваші бізнес-процеси",
      "advantages.missed.title": "Захист від втрати клієнтів",
      "advantages.missed.desc": "Гнучкі сценарії розподілу, мобільні застосунки, найкращий на ринку інтерфейс контролю обробки пропущених дзвінків",
      "advantages.support.title": "Підтримка яку ви заслуговуєте",
      "advantages.support.desc": "95% клієнтів оцінюють нашу підтримку як «Добре» або «Відмінно». Середній час відповіді — 2 хвилини",
      "advantages.recordings.title": "Безлімітне зберігання записів розмов",
      "advantages.recordings.desc": "Безкоштовне необмежене зберігання записів дзвінків на всіх тарифах",
      "advantages.analytics.title": "Найпотужніші аналітика та звітність",
      "advantages.analytics.desc": "Дашборди в реальному часі, кастомні звіти та AI-інсайти по кожному дзвінку",
      "advantages.ukraine.title": "Кришталево-чистий зв'язок",
      "advantages.ukraine.desc": "Чистий SIP без GSM-шлюзів — висока стабільність та відмінна якість голосу на кожному дзвінку",

      "profile.title": "Заповніть ваш профіль",
      "profile.editTitle": "Редагувати профіль",
      "profile.firstName": "Ім'я",
      "profile.lastName": "Прізвище",
      "profile.phone": "Корпоративний телефон",
      "profile.phoneExtension": "Добавочний",
      "profile.phoneExtensionHelper": "Код співробітника в IVR (2-6 цифр)",
      "profile.uploadPhoto": "Завантажити фото",
      "profile.changePhoto": "Змінити фото",
      "profile.save": "Зберегти",
      "profile.saving": "Збереження...",
      "profile.cropTitle": "Обрізати фото",
      "profile.cropConfirm": "Застосувати",
      "profile.cropCancel": "Скасувати",
      "profile.menuItem": "Мій профіль",
      "profile.required": "Це поле обов'язкове",
      "profile.latinOnly": "Тільки латиницею",
      "profile.invalidPhone": "Телефон повинен починатися з + та містити 7-15 цифр",
      "profile.invalidExtension": "Добавочний повинен містити 2-6 цифр",
      "profile.photoRequired": "Будь ласка, завантажте фото профілю",
      "profile.subtitle": "Заповніть свої дані, щоб продовжити роботу з калькулятором",
      "profile.photoUploadRequired": "Завантажте власне фото",
      "profile.photoUploadExplanation": "Аватарка з Google показана як заглушка, але її використати не можна. Натисніть \"Завантажити фото з комп'ютера\" вище та оберіть файл — це єдиний спосіб активувати кнопку \"Зберегти\".",
      "profile.phoneFormatHelper": "Тільки міжнародний формат, без пробілів і символів. Приклад: +48739109524",
      "profile.uploadPhotoFromComputer": "Завантажити фото з комп'ютера",
      "profile.saveFailed": "Не вдалося зберегти профіль. Спробуйте ще раз або зверніться у підтримку."
    }
  },
  ru: {
    translation: {
      // Основные элементы интерфейса
      "calculator.title": "Калькулятор стоимости сервисов Ringostat",
      "calculator.monthlyCost": "Месячная стоимость сервисов",
      "calculator.addProduct": "Добавить продукт",
      "calculator.users": "Пользователи Бизнес-телефонии",
      "calculator.usersLabel": "Пользователи",
      "calculator.total": "Сумма",
      "calculator.totalPerMonth": "Сумма в месяц",
      "calculator.generateOffer": "Сгенерировать оффер",
      "calculator.placeholderAdd": "Добавьте хотя бы один продукт для расчета стоимости",
      "calculator.selectRegion": "Выберите регион",
      
      // Продукты
      "calculator.businessPhone": "Business Phone",
      "calculator.callTracking": "Call Tracking",
      "calculator.ai": "Речевая аналитика с ИИ",
      "calculator.callback": "Callback",
      "calculator.phoneNumbers": "Номера телефонов",
      "calculator.voiceTraffic": "Пакеты минут",
      "calculator.omnichannelChat": "Омниканальный чат",
      "calculator.aiConversation": "Речевая аналитика с ИИ",
      "calculator.aiConversationLabel": "Речевая аналитика с ИИ",
      
      // Основные действия
      "calculator.cancel": "Отменить",
      "calculator.apply": "Применить",
      "calculator.add": "Добавить",
      "calculator.update": "Обновить",
      "common.ok": "ОК",
      "common.cancel": "Отменить",
      "common.apply": "Применить",
      "common.close": "Закрыть",
      "common.reset": "Сбросить",

      // Переводы для страницы логина
      "login.title": "Вход в калькулятор цен Ringostat",
      "login.welcome": "Используйте свой корпоративный Google аккаунт (@ringostat.com)",
      "login.continueWithGoogle": "Продолжить через Google",

      "calculator.omnichannelChatFmcInfo": "Omnichannel Chat доступен только с Business Phone. При FMC редактирование недоступно.",
      "calculator.omnichannelChatLimitInfoWithValue": "Максимум для чата — {{max}} (равен количеству пользователей Business Phone). Чтобы указать больше в поле, сначала увеличьте Business Phone.",
      
      // Секции
      "calculator.addProductsTitle": "Добавить продукты",
      "calculator.selectedProductsTitle": "Выбранные продукты",
      "calculator.summary": "Итог",
      "calculator.estimatedTotal": "Ориентировочная сумма",
      "calculator.currency": "/мес",
      "calculator.noItemsSelected": "Продукты не выбраны",
      "calculator.addProducts": "Добавить продукты",
      "calculator.allProductsSelected": "Вы выбрали все доступные продукты! 🎉",
      
      // Единицы измерения
      "calculator.sessions": "Сессий Call Tracking/день",
      "calculator.sessionsLabel": "Сессии",
      "calculator.sessionsInputLabel": "Сессий колтрекинга",
      "calculator.aiMinutesInputLabel": "Минут ИИ-аналитики",
      "calculator.callbackSessionsInputLabel": "Сессий Callback",
      "calculator.businessPhoneUsers": "пользователей",
      "calculator.fmcUsers": "пользователей",
      "calculator.callTrackingSlots": "слотов",
      "calculator.aiMinutes": "минут",
      "calculator.callbackSessions": "сессий",
      "calculator.phoneNumbersCount": "номеров",
      "calculator.chatUsers": "пользователей",
      "calculator.chatUsersLabel": "Количество пользователей",
      "calculator.minutes": "минут",
      "calculator.numbers": "номеров",
      
      // Voice Traffic
      "calculator.voiceTrafficMinutes": "Количество минут голосового трафика в месяц",
      "calculator.voiceTrafficPackage": "Пакет",
      "calculator.voiceTrafficPackageUA": "Пакет минут UA",
      "calculator.voiceTrafficPackageKZ": "Пакет минут KZ",
      "calculator.voiceTrafficPackageTooltip": "Выберите пакет вручную или позвольте системе выбрать наиболее выгодный",
      "calculator.voiceTrafficSelectedPackages": "Выбранные пакеты",
      "calculator.voiceTrafficCustomAmount": "Депозит на связь",
      "calculator.voiceTrafficSettings": "Настройки голосового трафика",
      "calculator.voiceTrafficCountries": "Страны",
      "calculator.voiceTrafficCountriesDescription": "Выберите страны для пакетов голосового трафика. Вы можете выбрать несколько стран.",
      "calculator.voiceTrafficCustomAmountDescription": "Использовать кастомную сумму вместо автоматического выбора пакета",
      "calculator.voiceTrafficSummary": "Система автоматически выберет лучшие пакеты для {{count}} стран на основе ваших потребностей в минутах.",
      "calculator.voiceTrafficSelectedCountries": "Выбранные страны: {{countries}}",
      "calculator.voiceTrafficCustomAmountInput": "Депозит на связь",
      "calculator.voiceTrafficPackageDetails": "{{includedMinutes}} минут включено",
      "calculator.voiceTrafficOverageMinutes": "дополнительных минут",
      "calculator.voiceTrafficOverageText": "сверх пакета",
      "calculator.voiceTrafficOverageShort": "сверх пакета",
      "calculator.voiceTrafficPerMinute": "руб/мин",
      "calculator.voiceTrafficCurrencyUAH": "грн/мин",
      "calculator.voiceTrafficCurrencyKZT": "тенге/мин",
      "calculator.voiceTrafficCurrencyPLN": "зл/мин",
      "calculator.voiceTrafficCurrencyEUR": "€/мин",
      "calculator.voiceTrafficVolumeUA": "Объем исходящей связи в Украине",
      "calculator.voiceTrafficVolumeKZ": "Объем исходящей связи в Казахстане",
      "calculator.voiceTrafficVolumePL": "Объем исходящей связи в Польше",
      "calculator.voiceTrafficMinutesShort": "мин.",
      "calculator.voiceTrafficMinutesUnit": "минут",
      "calculator.voiceTrafficLabel": "Пакет минут",
      "calculator.voiceTrafficDesc": "Количество минут голосового трафика в месяц",
      
      // Subscription планы  
      "subscription.360Days": "360 дней (бонус 20%)",
      "subscription.360DaysCustom": "360 дней (бонус {{discount}}%)",
      "subscription.360DaysNoBonus": "360 дней",
      "subscription.180Days": "180 дней",
      "subscription.180DaysCustom": "180 дней (бонус {{discount}}%)",
      "subscription.90Days": "90 дней",
      "subscription.12MonthContract": "12-месячный контракт",
      "subscription.360DaysSplit": "360 дней (рассрочка)",
      "subscription.toPay": "к оплате",
      "subscription.savings": "экономия",
      "subscription.perYear": "/год",
      "subscription.perMonth": "/мес",
      "subscription.days": "дней",
      "subscription.bonus": "бонус",
      "subscription.splitPayment": "рассрочка",
      "subscription.vatIncluded": "С НДС 20%: {{amount}}",
      "calculator.discount360Days": "360-дневная скидка",
      "calculator.discount180Days": "180-дневная скидка",
      
      // История предложений
      "history.title": "История предложений",
      "history.description": "Просматривайте и управляйте всеми своими сгенерированными предложениями и сравнениями",
      "history.dateTime": "Дата и время",
      "history.type": "Тип",
      "history.userEmail": "Email пользователя",
      "history.link": "Ссылка",
      "history.offer": "Предложение",
      "history.comparison": "Сравнение",
      "history.noHistory": "Пока нет сравнений",
      "history.createFirst": "Создайте ваше первое сравнение в калькуляторе",
      "history.openInNewTab": "Открыть в новой вкладке",
      "history.copyLink": "Скопировать ссылку",
      "history.useAsTemplate": "Использовать как шаблон",
      "history.templateUnavailable": "Данные шаблона недоступны",
      "history.copied": "Скопировано!",
      "history.offers": "предложений",
      "history.offersInComparison": "Предложения в этом сравнении",
      "history.clientName": "Название компании",
      "history.searchByClientName": "Поиск по названию компании...",
      "history.noClientName": "Нет названия компании",
      "history.filters": "Фильтры",
      "history.selectDateRange": "Выберите диапазон дат",
      
      // Предложения
      "offers.offerShareInfo": "Поделитесь этой ссылкой с клиентами, чтобы показать им детальное ценовое предложение.",
      "offers.comparisonGenerated": "Сравнение сгенерировано!",
      "offers.comparisonGeneratedDescription": "Ваше ценовое сравнение успешно создано",
      "offers.comparisonLink": "Ссылка на сравнение:",
      "offers.comparisonShareInfo": "Поделитесь этой ссылкой с клиентами, чтобы показать им сравнение разных ценовых опций.",
      
      // Выбор дат
      "datePicker.today": "Сегодня",
      "datePicker.yesterday": "Вчера",
      "datePicker.last7Days": "Последние 7 дней",
      "datePicker.last30Days": "Последние 30 дней",
      "datePicker.currentMonth": "Текущий месяц",
      "datePicker.previousMonth": "Предыдущий месяц",
      "datePicker.selectDateRange": "Выберите диапазон дат",
      "datePicker.quickSelect": "Быстрый выбор",
      "datePicker.customRange": "Кастомный диапазон",
      "datePicker.from": "От",
      "datePicker.to": "До",
      "datePicker.clear": "Очистить",
      
      // Offers и коммерческие предложения
      "offers.notIncluded": "Не включено",
      "offers.included": "Включено",
      "offers.notAvailable": "Недоступно",
      "offers.perMonth": "/мес",
      "offers.backToCalculator": "Назад к калькулятору",
      "offers.offerDetails": "Детали предложения",
      "offers.comparisonCount": "Сравнение ({{count}}/5)",
      "offers.offersComparison": "Сравнение предложений",
      "offers.offersComparisonFor": "Сравнение предложений для {{companyName}}",
      "offers.proposalFor": "Предложение '{{offerName}}' для {{companyName}}",
      "offers.proposalForCompany": "Предложение для {{companyName}}",
      "offers.proposalDetails": "Предложение '{{offerName}}'",
      "offers.reviewOfferDetails": "Просмотрите детали предложения и выберите тарифный план",
      "offers.currencyDisclaimer": "Стоимость формируется в долларах, оплата в гривнах по актуальному курсу на день оплаты",
      "comparison.noCompanyName": "Нет названия компании",
      "offers.compareOffersDescription": "Сравните различные предложения и выберите лучшее для вашего бизнеса",
      "offers.offer": "Предложение",
      "offers.productsAndUsage": "Продукты и использование",
      "offers.subscriptionOptions": "Варианты подписки",
      "offers.available": "Доступно",
      "offers.exportToPDF": "Экспорт в PDF",
      "offers.validUntil": "Действительна до {{date}}",
      "offers.validUntilShort": "действительна до",
      "offers.validityPeriod": "14 дней с даты генерации",
      "offers.toPay": "к оплате",
      "offers.savePerYear": "экономия",
      "offers.perYear": "/год",
      "offers.plan360days20": "360 дней (бонус 20%)",
      "offers.savings": "экономия",
      "offers.annualPayment": "годовой платеж",
      "offers.plan360daysNoBonus": "360 дней (без бонуса)",
      "offers.plan180days": "180 дней (бонус 10%)",
      "offers.plan90days": "90 дней",
      "offers.plan12month": "12-месячный контракт",
      "offers.plan360split": "360 дней (рассрочка)",
      "offers.semiAnnualPayment": "за 6 месяцев",
      "offers.detailedOffer": "Детальное предложение",
      "offers.removeFromComparison": "Удалить из сравнения",
      "offers.noOffersToCompare": "Нет предложений для сравнения",
      "offers.returnToCalculatorToCreate": "Вернуться в калькулятор для создания новых предложений",
      "offers.generateOffer": "Создать предложение",
      "offers.selectTabsDescription": "Выберите конфигурации цен, которые хотите включить в предложение:",
      "offers.selectAll": "Выбрать все",
      "offers.configuration": "Конфигурация",
      "offers.generateComparison": "Создать сравнение",
      "offers.offerGenerated": "Предложение создано!",
      "offers.offerGeneratedDescription": "Ваше коммерческое предложение успешно создано",
      "offers.offerLink": "Ссылка на предложение:",
      "offers.copyLink": "Скопировать ссылку",
      "offers.openInNewTab": "Открыть в новой вкладке",
      "offers.linkCopied": "Ссылка скопирована в буфер обмена!",
      "offers.yourProposal": "Ваше предложение",
      "offers.monthlyForecast": "Прогнозируемая стоимость в месяц",
      "offers.chooseThisPlan": "Выбрать этот план",
      "offers.monthlyCost": "Месячная стоимость",
      "offers.clientName": "Название компании *",
      "offers.clientNamePlaceholder": "Введите название компании...",
      "offers.clientNameRequired": "Название компании обязательно",
      "offers.generating": "Создание...",
      "offers.noTabsAvailable": "Нет доступных конфигураций цен",
      
      // Дополнительные общие переклады
      "common.backToCalculator": "Назад к калькулятору",
      "Settings": "Настройки",
      "Region": "Регион",
      "Initial Data": "Исходные данные",
      "Service Cost": "Стоимость услуг",
      "Business Phone": "Бизнес-телефон",
      "Call Tracking": "Колтрекинг",
      "Total": "Итого",
      
      // Страны
      "countries.ukraine": "Украина",
      "countries.kazakhstan": "Казахстан", 
      "countries.poland": "Польша",
      "voicePackages.noPackagesHint": "Некоторые страны недоступны — нет активных пакетов минут",

      // Калькулятор расширенные настройки
      "calculator.aiConversationCalls": "звонков",
      "calculator.monthlyForecast": "Прогнозируемая стоимость в месяц",
      "calculator.minute": "минута",
      "calculator.pricePerMinute": "Цена за минуту",
      "calculator.totalPrice": "Общая цена",
      "calculator.customSettingsEnabled": "Пользовательские настройки включены",
      "calculator.aiSettingsTitle": "Настройки ИИ анализа разговоров",
      "calculator.enableNonEnglishAnalysis": "Включить анализ на других языках",
      "calculator.nonEnglishAnalysisTooltip": "Единая цена: $0.03 за минуту для всех регионов (кроме Европы: €0.03)",
      "calculator.resetToDefault": "Сбросить по умолчанию",
      "calculator.pricingInformation": "Информация о ценах:",
      "calculator.standardAnalysis": "Стандартный анализ:",
      "calculator.nonEnglishAnalysis": "Анализ на других языках:",
      "calculator.monthlyTotal": "Месячная стоимость",
      "calculator.paymentOptions": "Варианты оплаты",
      "calculator.paymentSummary": "Сводка платежей",
      "calculator.standardPlan": "360 дней",
      "calculator.bestValue": "Лучшее предложение - ",
      "calculator.sixMonthPlan": "Подписка на 180 дней",
      "calculator.threeMonthMinimum": "Подписка на 90 дней",
      "calculator.monthlyContract": "12-месячный контракт",
      "calculator.splitPayment": "Подписка на 360 дней (рассрочка)",
      "calculator.moreExpensivePerYear": "дороже в год",
      "calculator.advancedDiscountSettings": "Расширенные настройки скидок",
      "calculator.advancedDiscountHint": "Нажмите Cmd+Shift+D (Mac) или Ctrl+Shift+D (PC) чтобы скрыть",
      "calculator.businessPhoneUsersLabel": "Количество пользователей бизнес-телефона",
      "calculator.businessPhoneUsersLabelStandalone": "Количество пользователей",
      "calculator.fmcUsersLabel": "Количество пользователей FMC",
      "calculator.fmcUsersLabelStandalone": "Количество пользователей",
      "calculator.businessPhoneSettings": "Настройки Business Phone",
      "calculator.businessPhoneType": "Тип Business Phone",
      "calculator.businessPhoneOnly": "Business Phone",
      "calculator.fmcOnly": "FMC",
      "calculator.businessPhoneFmc": "Business Phone + FMC",
      "calculator.businessPhonePricing": "Business Phone: €20 за пользователя",
      "calculator.fmcPricing": "FMC: $5 за пользователя",
      "calculator.comparePlans": "Сравнить",
      "calculator.compareFeatures": "Сравнить функции",
      "calculator.comparePlansTitle": "Сравнение тарифов",
      "calculator.feature": "Функция",
      "calculator.selected": "Выбрано",
      "calculator.compareTip": "Нажмите на колонку тарифа чтобы выбрать его",
      "calculator.included": "ВКЛЮЧЕНО",
      "calculator.includedInTier": "Включено в тариф {{tier}}",
      "calculator.includedInProCorporate": "Включено в Pro/Corporate",
      "calculator.perUser": "/пользователь",
      "calculator.comingSoon": "Скоро",
      "calculator.uaBusinessDiscount": "Скидка для украинского бизнеса",
      "calculator.features.aiConversation": "Речевая аналитика (AI)",
      "calculator.features.aiConversationBasicLevel": "Базовый",
      "calculator.features.aiConversationProLevel": "Профессиональный Eniq AI",
      "calculator.features.omnichannelChat": "Омниканальный чат",
      "calculator.features.callback": "Callback",
      "calculator.features.realTimeReports": "Отчеты в реальном времени",
      "calculator.features.agentStatuses": "Статусы сотрудников",
      "calculator.features.callWhisper": "Режим суфлера",
      "calculator.features.csat": "CSAT",
      "calculator.features.customerSuccessTeam": "Customer Success",
      "calculator.features.powerDialer": "Power Dialer",
      "calculator.features.autoMissedProcessing": "Автоматизация пропущенных",
      "calculator.features.prioritySupport": "Приоритетная поддержка",
      "calculator.features.dedicatedVipCs": "VIP Customer Success",
      "calculator.features.customLookerReports": "Кастомные отчеты Looker",
      "calculator.features.customUserRoles": "Гибкие настройки ролей",
      "calculator.features.customCrmIntegration": "Кастомная CRM интеграция",
      "calculator.eniqCompare.title": "Сравнение тарифов Eniq AI",
      "calculator.eniqCompare.note": "Цена указана за одного пользователя в месяц",
      "calculator.eniqCompare.models": "AI-модели",
      "calculator.eniqCompare.modelsStandard": "Стандартные модели",
      "calculator.eniqCompare.modelsPro": "Premium модели",
      "calculator.eniqCompare.promptLimit": "Длина промпта анализа",
      "calculator.eniqCompare.promptLimitStandard": "До 30k символов",
      "calculator.eniqCompare.promptLimitPro": "Без ограничений",
      "calculator.eniqCompare.insights": "AI Insights",
      "calculator.eniqCompare.insightsStandard": "Стандартные лимиты",
      "calculator.eniqCompare.insightsPro": "Расширенные лимиты",
      "calculator.eniqCompare.knowledgeBase": "База знаний",
      "calculator.eniqCompare.knowledgeBaseStandard": "Стандартные лимиты",
      "calculator.eniqCompare.knowledgeBasePro": "Расширенные лимиты",
      "calculator.eniqCompare.training": "AI Тренинг",
      "calculator.eniqCompare.trainingStandard": "1 час на пользователя",
      "calculator.eniqCompare.trainingPro": "Расширенный лимит",
      "calculator.eniqTierLabel": "Тариф Eniq AI",
      "calculator.eniqTierStandard": "Standard",
      "calculator.eniqTierPro": "Pro",
      "calculator.eniqUsersLabel": "Количество пользователей",
      "calculator.eniqUsersLinkedInfo": "Количество пользователей Eniq AI привязано к Business Phone/FMC",
      "calculator.eniqUpgradeDiff": "Standard уже входит в Corporate — доплачиваете только разницу",
      "calculator.eniqMinBillableUsers": "Eniq AI всегда тарифицируется минимум за {{count}} пользователей",
      "calculator.fmcRegionWarning.title": "Предупреждение о смене региона",
      "calculator.fmcRegionWarning.message": "Вы переключаетесь на регион, где продукт FMC не поддерживается. FMC будет удален из вашего выбора. Хотите продолжить?",
      "calculator.fmcRegionWarning.confirm": "Сменить регион",
      "calculator.callTrackingSettings": "Настройки Call Tracking",
      "calculator.trackingType": "Тип отслеживания",
      "calculator.dynamicTracking": "Динамический (по сессиям)",
      "calculator.staticTracking": "Статический (фиксированные источники)",
      "calculator.combinedTracking": "Комбинированный (динамический + статический)",
      "calculator.enableCallMeButton": "Включить кнопку \"Call me\"",
      "calculator.numberFormatsQuantity": "Количество форматов номеров",
      "calculator.globalSettings": "Глобальные настройки",
      "calculator.globalSettingsPlaceholder": "Глобальные настройки будут доступны здесь",
      "calculator.showAdvancedTier": "Показать тариф Advanced",
      "calculator.showAdvancedTierDescription": "Включить скрытый тариф Advanced для Бизнес Телефона (UA, Central Asia, Other регионы)",
      "calculator.showPricesWithoutBonuses": "Показывать цены без долгосрочных бонусов",
      "calculator.showPricesWithoutBonusesDescription": "Прогноз ежемесячной платы будет показывать цены без скидки за 360-дневную подписку",
      "calculator.subscriptionOptions": "Варианты подписки",
      "calculator.subscription12Month": "12-месячный контракт",
      "calculator.subscriptionSplitPayment": "Рассрочка платежа",
      "calculator.legacyOptions": "Legacy Options",
      "calculator.subscription90Days": "Подписка на 90 дней",
      "calculator.subscription180Days": "Подписка на 180 дней",
      "calculator.unitPrice": "Цена за единицу",
      "calculator.noPhoneNumbers": "Номера телефонов пока не добавлены. Нажмите \"Добавить номер телефона\", чтобы добавить.",
      "calculator.addPhoneNumber": "Добавить номер телефона",
      "calculator.addFromCatalog": "Добавить из каталога",
      "calculator.pleaseEnterName": "Пожалуйста, введите название номера телефона",
      "calculator.allProductsAdded": "Все доступные продукты добавлены",
      "calculator.dailyWebsiteSessions": "Сессий на сайте в день",
      "calculator.staticSourcesDescription": "Статические источники (1 источник = 1 номер телефона)",
      "calculator.minutesToAnalyze": "Количество минут для анализа в месяц",
      "calculator.aiUsersLabel": "Количество пользователей",
      "calculator.aiUsersLinkedInfo": "Количество пользователей ИИ привязано к количеству пользователей Business Phone/FMC",
      "calculator.chatUsersLinkedInfo": "Количество пользователей чата привязано к количеству пользователей Business Phone (FMC-пользователи не могут пользоваться чатом)",
      "calculator.phoneNumbersRequired": "Необходимые номера телефонов",
      "calculator.phoneNumberName": "Название номера телефона",
      "calculator.quantity": "Количество",
      
      // Eniq AI переклады
      "calculator.eniqAiLabel": "Eniq AI",
      "calculator.eniqAiDesc": "ИИ-анализ разговоров",
      "calculator.eniqAiMinutes": "Минуты анализа",
      "calculator.eniqAiMinutesInput": "Количество минут",
      "calculator.eniqAiUnits": "юнитов",
      "calculator.eniqAiPremiumModels": "Премиум модели",
      "calculator.eniqAiSettings": "Настройки Eniq AI",
      "calculator.eniqAiAnalysisType": "Тип анализа",
      "calculator.eniqAiPremiumDescription": "Анализ высокой точности с продвинутыми ИИ моделями (1 кредит за минуту)",
      "calculator.eniqAiStandardNote": "Стандартные модели",
      "calculator.eniqAiStandardDescription": "Экономичный анализ со стандартными ИИ моделями (0.33 кредита за минуту)",
      "calculator.eniqAiDescription": "ИИ-анализ разговоров с гибкими тарифными планами в зависимости от ваших потребностей.",
      "calculator.eniqAiOptimalPlan": "Оптимальный план",
      "calculator.eniqAiIncluded": "минут включено",
      "calculator.eniqAiExtraMinutes": "дополнительных минут",
      "calculator.eniqAiUnitsIncluded": "юнитов включено",
      "calculator.eniqAiExtraUnits": "дополнительных юнитов",
      "calculator.eniqAiTariff": "Тариф",
      "calculator.eniqAiCalculationError": "Не удалось рассчитать стоимость",
      "calculator.calculating": "Расчет...",
      "calculator.eniqAiPlanStart": "Start",
      "calculator.eniqAiPlanPro": "Pro",
      "calculator.eniqAiPlanMax": "Max",
      "calculator.eniqAiPlanScale": "Scale",

      // VoiceBot
      "calculator.voicebotLabel": "Голосовой бот",
      "calculator.voicebotDesc": "Автоматические звонки на базе ИИ",
      "calculator.voicebotMinutesInput": "Количество минут",
      "calculator.voicebotMinutesUnit": "мин",
      "calculator.voicebotSettings": "Настройки VoiceBot",
      "calculator.voicebotMode": "Режим кампании",
      "calculator.voicebotAiMode": "AI VoiceBot",
      "calculator.voicebotAiDescription": "ИИ-разговоры (1000 юнитов за минуту)",
      "calculator.voicebotRoboCallMode": "RoboCall",
      "calculator.voicebotRoboCallDescription": "Автоматические звонки без ИИ (100 юнитов за минуту)",
      "calculator.voicebotExtraChannels": "Дополнительные робо-каналы",
      "calculator.voicebotChannelsIncluded": "3 канала включены в каждый план",
      "calculator.voicebotExtraChannelsCount": "Дополнительные каналы",
      "calculator.voicebotChannelPrice": "$25/мес за канал",
      "calculator.voicebotTotalChannels": "всего каналов",
      "calculator.voicebotPerMonth": "мес",
      "calculator.voicebotImplementationFee": "Плата за внедрение",
      "calculator.voicebotImplementationFeeLabel": "Внедрение VoiceBot",
      "calculator.voicebotImplementationFeeDesc": "Разовая оплата за внедрение и настройку VoiceBot",
      "calculator.voicebotMinIncluded": "мин включено",
      "calculator.voicebotExtraMin": "доп. мин",
      "calculator.planLite": "Lite",
      "calculator.tariff": "Тариф",

      // Расширенные настройки
      "calculator.advancedSettings": "Расширенные настройки",
      "calculator.veryCustomProductDiscount": "Пользовательская скидка на продукт",
      "calculator.customDiscountNote": "Применяется после скидок на пакеты (0-100%)",
      "calculator.advancedSettingsHint": "Доступ: Двойной клик по заголовку или Ctrl+Shift+C",
      "calculator.omnichannelChatSettings": "Настройки Омниканального чата",
      "calculator.omnichannelChatSettingsDescription": "В данный момент дополнительные настройки для Омниканального чата недоступны.",

      // Недостающие ключи для выравнивания с EN/UA
      "admin.syncDIDWW": "Синхр. DIDWW Docs",
      "admin.syncDIDWWAlreadyRunning": "Синхронизация уже выполняется",
      "admin.syncDIDWWError": "Не удалось синхронизировать требования DIDWW",
      "admin.syncDIDWWStarted": "Синхронизация DIDWW запущена, подождите...",
      "admin.syncDIDWWSuccess": "Синхронизировано {{countries}} стран, обновлено {{entries}} записей",
      "admin.syncDIDWWSyncing": "Синхронизация...",
      "calculator.addMore": "+ Добавить еще",
      "calculator.addPhoneNumbers": "Добавить номера телефонов",
      "calculator.aiConversationDesc": "Количество минут для анализа в месяц",
      "calculator.betaPricing": "Бета-цена: применена скидка 50%",
      "calculator.betaProduct": "BETA -50%",
      "calculator.businessPhoneDesc": "Количество пользователей, которым нужны функции Business Phone",
      "calculator.businessPhoneLabel": "Business Phone",
      "calculator.callTrackingDesc": "Сессии сайта в день",
      "calculator.callTrackingLabel": "Call Tracking",
      "calculator.callbackDesc": "Ориентировочное количество запросов Callback в месяц",
      "calculator.callbackLabel": "Callback",
      "calculator.docsRequired": "Требуются документы",
      "calculator.editPhoneNumbers": "Редактировать номера телефонов",
      "calculator.fmcLabel": "FMC",
      "calculator.fromCatalog": "Из каталога",
      "calculator.offerPageDesc": "Здесь будет страница сгенерированного коммерческого предложения для клиента с брендингом Ringostat.",
      "calculator.offerPageTitle": "Коммерческое предложение (демо)",
      "calculator.omnichannelChatDesc": "Пользователи для онлайн-чата и мессенджеров (Viber, Telegram, Facebook)",
      "calculator.omnichannelChatWarning": "Омниканальный чат требует сначала добавить Business Phone.",
      "calculator.omnichannelChatWarning.title": "Требования к продукту",
      "calculator.phoneNamePlaceholder": "Введите для поиска в каталоге...",
      "calculator.phoneNumbersDesc": "Покупка и управление номерами телефонов",
      "calculator.pricePerNumber": "Цена за номер",
      "calculator.usersInputLabel": "Пользователи Business Phone",
      "common.create": "Создать",
      "common.delete": "Удалить",
      "common.save": "Сохранить",
      "voicePackages.actions": "Действия",
      "voicePackages.active": "Активный",
      "voicePackages.addPackage": "Добавить пакет",
      "voicePackages.adjustFilters": "Попробуйте изменить фильтры",
      "voicePackages.allCountries": "Все",
      "voicePackages.confirmDelete": "Удалить пакет?",
      "voicePackages.confirmDeleteText": "Вы уверены, что хотите удалить \"{{name}}\" ({{country}})?",
      "voicePackages.country": "Страна",
      "voicePackages.created": "Пакет создан",
      "voicePackages.currency": "Валюта",
      "voicePackages.delete": "Удалить",
      "voicePackages.deleteError": "Не удалось удалить пакет",
      "voicePackages.deleted": "Пакет удален",
      "voicePackages.edit": "Редактировать",
      "voicePackages.editPackage": "Редактировать пакет",
      "voicePackages.fetchError": "Не удалось загрузить пакеты",
      "voicePackages.isActive": "Активный",
      "voicePackages.loading": "Загрузка пакетов...",
      "voicePackages.minutes": "Минуты",
      "voicePackages.name": "Название",
      "voicePackages.noEntries": "Пакеты не найдены",
      "voicePackages.overageLocal": "Сверх пакета лок.",
      "voicePackages.overageRateLocal": "Тариф сверх пакета",
      "voicePackages.overageUsd": "Сверх пакета USD",
      "voicePackages.perMinLocal": "За мин. лок.",
      "voicePackages.perMinUsd": "За мин. USD",
      "voicePackages.priceLocal": "Цена локальная",
      "voicePackages.pricePerMinuteLocal": "Цена за минуту",
      "voicePackages.priceUsd": "Цена USD",
      "voicePackages.searchPlaceholder": "Поиск по названию...",
      "voicePackages.showingEntries": "Показано {{showing}} из {{total}} записей",
      "voicePackages.subtitle": "Управление пакетами минут голосового трафика",
      "voicePackages.title": "Пакеты минут",
      "voicePackages.toggleError": "Не удалось изменить статус",
      "voicePackages.updated": "Пакет обновлен",
      "voicePackages.usdInfo": "Цены в USD обновляются автоматически ежедневным cron-заданием",
      
      // Валюты
      "currency.display": "Валюта",
      "currency.uahNote": "Стоимость формируется в долларах, оплата в гривнах по актуальному курсу на день оплаты.",
      "currency.uah": "грн",
      "currency.uahSymbol": "грн",
      "currency.usd": "USD",
      "currency.eur": "EUR",
      
      // Короткие переклады
      "calculator.perMonthShort": "/мес",
      
      // Одноразовые платежи
      "calculator.oneTimePayments": "Одноразовые платежи",
      "calculator.phoneNumberActivation": "Активация номеров телефонов",
      "calculator.eniqImplementationFee": "Внедрение Eniq AI",
      "calculator.enableImplementationFee": "Плата за внедрение",
      "calculator.implementationFeeDescription": "Одноразовая плата за внедрение и настройку Eniq AI",
      "calculator.implementationFeeAmount": "Сумма внедрения",
      
      // Настройки номеров телефонов
      "calculator.phoneNumbersSettings": "Настройки номеров телефонов",
      "calculator.enablePhoneActivation": "Включить плату за активацию",
      "calculator.activationFee": "Активация",
      "calculator.activationTotal": "Плата за активацию",

      // Selected Plan Features
      "calculator.selectedPlanIncludes": "Выбранный план включает",

      // Basic tier features
      "calculator.feature.mobileDesktopApps": "Приложения для всех устройств",
      "calculator.feature.callRecordingUnlimited": "Безлимитная запись звонков",
      "calculator.feature.integrations50": "50+ готовых интеграций",
      "calculator.feature.reportsControlMissed": "Мощные отчеты и статистика",
      "calculator.feature.flexibleRouting": "Гибкая маршрутизация",
      "calculator.feature.ivrVoicemail": "IVR, голосовая почта",

      // Pro tier features
      "calculator.feature.allBasicFeatures": "Все функции тарифа Basic",
      "calculator.feature.callTranscription": "Транскрипция звонков",
      "calculator.feature.aiQualityScoring": "Оценка качества звонков (AI)",
      "calculator.feature.omnichannelMessengers": "Чат и мессенджеры",
      "calculator.feature.callbackWidget": "Виджет callback",
      "calculator.feature.advancedReportsSchedule": "Расширенные отчеты",

      // Corporate tier features
      "calculator.feature.allProFeatures": "Все функции тарифа Pro",
      "calculator.feature.advancedConversationAnalytics": "Расширенная речевая аналитика",
      "calculator.feature.powerDialer": "Power Dialer",
      "calculator.feature.missedCallsAutomation": "Автообработка пропущенных",
      "calculator.feature.personalManager": "Персональный менеджер",
      "calculator.feature.prioritySupport": "Приоритетная поддержка",
      "calculator.feature.customReportsCrm": "Кастомные отчеты и интеграции",

      // Tabs
      "tabs.newCalculation": "Новый расчёт",
      "tabs.allCalculations": "Все расчёты",

      // Test Scenarios Dashboard
      "testScenarios.title": "Панель тестовых сценариев",
      "testScenarios.subtitle": "Визуализация и проверка сценариев ценообразования",
      "testScenarios.info": "Эта панель показывает все тестовые сценарии ценообразования. Нажмите \"Применить\" чтобы создать новую вкладку калькулятора с конфигурацией сценария.",
      "testScenarios.backToCalculator": "Назад к калькулятору",
      "testScenarios.total": "Всего: {{count}}",
      "testScenarios.passed": "Пройдено: {{count}}",
      "testScenarios.failed": "Не пройдено: {{count}}",
      "testScenarios.search": "Поиск",
      "testScenarios.searchPlaceholder": "Поиск по описанию...",
      "testScenarios.product": "Продукт",
      "testScenarios.tier": "Тариф",
      "testScenarios.region": "Регион",
      "testScenarios.status": "Статус",
      "testScenarios.all": "Все",
      "testScenarios.passedOnly": "Пройденные",
      "testScenarios.failedOnly": "Не пройденные",
      "testScenarios.description": "Описание",
      "testScenarios.quantity": "Количество",
      "testScenarios.expected": "Ожидаемо",
      "testScenarios.actual": "Фактически",
      "testScenarios.actions": "Действия",
      "testScenarios.apply": "Применить",
      "testScenarios.testPassed": "Тест пройден",
      "testScenarios.testFailed": "Тест не пройден",
      "testScenarios.noResults": "Нет сценариев по вашим фильтрам",
      "testScenarios.noConfig": "Для этого сценария нет конфигурации калькулятора",
      "testScenarios.tabCreated": "Вкладка \"{{name}}\" создана! Настройте вручную или проверьте конфигурацию сценария.",
      "testScenarios.applyError": "Ошибка создания вкладки",

      "admin.users": "Пользователи",
      "admin.usersManagement": "Управление пользователями",
      "admin.usersDescription": "Управляйте ролями пользователей и просматривайте активность",
      "admin.searchUsers": "Поиск по email или имени...",
      "admin.showingUsers": "Показано {{showing}} из {{total}} пользователей",
      "admin.name": "Имя",
      "admin.email": "Email",
      "admin.role": "Роль",
      "admin.actions": "Действия",
      "admin.loadingUsers": "Загрузка пользователей...",
      "admin.noUsers": "Пользователи не найдены",
      "admin.adjustSearch": "Попробуйте изменить поисковый запрос",
      "admin.viewHistory": "Просмотреть историю",
      "admin.roleUpdated": "Роль успешно обновлена",
      "admin.roleUpdateFailed": "Не удалось обновить роль",
      "admin.userHistory": "{{name}} — История",
      "admin.userHistoryShort": "История пользователя",
      "admin.backToUsers": "Назад к пользователям",
      "admin.selectedCount": "{{count}} выбрано",
      "admin.selectRole": "Выберите роль...",
      "admin.applyRole": "Применить",
      "admin.clearSelection": "Сбросить выбор",
      "admin.bulkSuccess": "Обновлено {{count}} пользователей",
      "admin.bulkPartial": "Обновлено {{success}}, ошибок {{fail}}",

      "offer.heroTitle": "Предложение для",
      "offer.yourProducts": "Ваши продукты",
      "offer.subscriptionOptions": "Варианты оплаты",
      "offer.oneTimePayments": "Единоразовые платежи",
      "offer.includedOneTimeFees": "Включённые единоразовые платежи",
      "offer.addedToPlanBelow": "↓ Включено в подписки ниже",
      "comparison.oneTimeAddedToTotal": "*Включено в подписку",
      "offer.oneTimeTotal": "Итого единоразово",
      "offer.advantages": "Почему Ringostat?",
      "offer.contactTitle": "Есть вопросы по этому предложению?",
      "offer.contactSubtitle": "Свяжитесь с вашим менеджером напрямую",
      "offer.contactSubtitleNamed": "Свяжитесь с {{name}} напрямую",
      "offer.callManager": "Позвонить вашему эксперту",
      "offer.emailManager": "Написать",
      "offer.salesRole": "Эксперт Ringostat",
      "offer.viewFullOffer": "Детальное предложение",
      "offer.heroDescription": "Контролируйте каждую коммуникацию, не теряйте ни одного клиента и освободите команду от рутины — с AI-платформой для коммуникаций Ringostat.",
      "offer.priceNote": "при оплате на год, без НДС",
      "comparison.heroDescription": "Выберите оптимальное решение для вашего бизнеса из предложенных вариантов. Каждое предложение подобрано под ваши потребности.",
      "comparison.paymentOptionsHint": "Длиннее срок — выше скидка",
      "comparison.variants": "{{count}} варианта",
      "comparison.yourOptions": "Ваши варианты",
      "comparison.products": "продуктов",
      "comparison.perYear": "/год",
      "comparison.product": "Продукт",
      "comparison.totalMonthly": "Итого / мес",
      "comparison.detailedComparison": "Детальное сравнение",
      "offer.comparePlans": "Сравнение тарифов Business Phone",
      "offer.comparisonTitle": "Сравнение предложений для {{client}}",
      "offer.included": "Включено",
      "offer.annualPlan": "Годовой план",
      "offer.saveBadge": "Экономия {{percent}}%",
      "offer.recommended": "Рекомендуется",
      "offer.perMonth": "/мес",
      "offer.validUntil": "Действительно до {{date}}",
      "offer.perYear": "/год",
      "offer.totalAnnual": "Итого: {{amount}}/год",
      "advantages.iso.title": "Сертификат ISO 27001",
      "offer.toPay": "к оплате",
      "offer.withVat": "С НДС 20%: {{amount}}",
      "offer.exportPDF": "Экспорт PDF",
      "offer.oneTimePaymentHint": "Единоразовая плата за подключение",
      "offer.perMonthLabel": "в месяц",
      "offer.acceptRecommendation": "Принять рекомендацию",
      "offer.selectPlan": "Выбрать план",
      "offer.saveBullet": "Экономия {{percent}}%",
      "offer.priceLocked": "Цена зафиксирована на 12 месяцев",
      "offer.dedicatedManager": "Выделенный менеджер",
      "offer.subscriptionBadge": "{{days}}-дневный план",
      "advantages.iso.desc": "Данные защищены международными стандартами безопасности",
      "advantages.apps.title": "Кроссплатформенные приложения",
      "advantages.apps.desc": "Нативные приложения для iOS, Android, Windows, macOS. Пользоваться Ringostat легко и удобно",
      "advantages.crm.title": "Самые гибкие интеграции с 50+ CRM",
      "advantages.crm.desc": "Бесшовная интеграция с Salesforce, HubSpot, Pipedrive, ZohoCRM и другими. Тонкая настройка под ваши бизнес-процессы",
      "advantages.missed.title": "Защита от потери клиентов",
      "advantages.missed.desc": "Гибкие сценарии распределения, мобильные приложения, лучший на рынке интерфейс контроля обработки пропущенных звонков",
      "advantages.support.title": "Поддержка которую вы заслуживаете",
      "advantages.support.desc": "95% клиентов оценивают нашу поддержку как «Хорошо» или «Отлично». Среднее время ответа — 2 минуты",
      "advantages.recordings.title": "Безлимитное хранение записей разговоров",
      "advantages.recordings.desc": "Бесплатное неограниченное хранение записей звонков на всех тарифах",
      "advantages.analytics.title": "Мощнейшая аналитика и отчётность",
      "advantages.analytics.desc": "Дашборды в реальном времени, кастомные отчёты и AI-инсайты по каждому звонку",
      "advantages.ukraine.title": "Кристально чистая связь",
      "advantages.ukraine.desc": "Чистый SIP без GSM-шлюзов — высокая стабильность и отличное качество голоса на каждом звонке",
      "calculator.phoneCatalog": "Каталог номеров",
      "calculator.addToOffer": "Добавить в предложение",
      "calculator.itemsSelected": "{{count}} выбрано",
      "calculator.fromPrice": "ОТ",
      "calculator.fromPriceHint": "Цена начинается от этой суммы",
      "calculator.noResults": "Номера не найдены",
      "calculator.selectCountry": "Страна",
      "calculator.selectCity": "Город",
      "calculator.selectProvider": "Провайдер",
      "calculator.searchNumbers": "Поиск...",
      "calculator.monthlyFee": "Абонплата",
      "calculator.country": "Страна",
      "calculator.city": "Город",
      "calculator.provider": "Провайдер",
      "calculator.code": "Код",
      "calculator.docsShort": "Док.",
      "calculator.commentShort": "Прим.",
      "calculator.requiredDocs": "Необходимые документы",
      "calculator.commentTitle": "Комментарий",
      "calculator.freeForTrial": "Триал",
      "calculator.freeForTrialYes": "Бесплатно на триал",

      "profile.title": "Заполните ваш профиль",
      "profile.editTitle": "Редактировать профиль",
      "profile.firstName": "Имя",
      "profile.lastName": "Фамилия",
      "profile.phone": "Корпоративный телефон",
      "profile.phoneExtension": "Добавочный",
      "profile.phoneExtensionHelper": "Код сотрудника в IVR (2-6 цифр)",
      "profile.uploadPhoto": "Загрузить фото",
      "profile.changePhoto": "Изменить фото",
      "profile.save": "Сохранить",
      "profile.saving": "Сохранение...",
      "profile.cropTitle": "Обрезать фото",
      "profile.cropConfirm": "Применить",
      "profile.cropCancel": "Отмена",
      "profile.menuItem": "Мой профиль",
      "profile.required": "Это поле обязательно",
      "profile.latinOnly": "Только латиницей",
      "profile.invalidPhone": "Телефон должен начинаться с + и содержать 7-15 цифр",
      "profile.invalidExtension": "Добавочный должен содержать 2-6 цифр",
      "profile.photoRequired": "Пожалуйста, загрузите фото профиля",
      "profile.subtitle": "Заполните свои данные, чтобы продолжить работу с калькулятором",
      "profile.photoUploadRequired": "Загрузите собственное фото",
      "profile.photoUploadExplanation": "Аватарка Google показана как заглушка, но использовать её нельзя. Нажмите \"Загрузить фото с компьютера\" выше и выберите файл — это единственный способ активировать кнопку \"Сохранить\".",
      "profile.phoneFormatHelper": "Только международный формат, без пробелов и символов. Пример: +48739109524",
      "profile.uploadPhotoFromComputer": "Загрузить фото с компьютера",
      "profile.saveFailed": "Не удалось сохранить профиль. Попробуйте ещё раз или обратитесь в поддержку."
    }
  },
  pl: {
    translation: {
      // Podstawowe elementy interfejsu
      "calculator.title": "Kalkulator kosztów usług Ringostat",
      "calculator.monthlyCost": "Miesięczny koszt usług",
      "calculator.addProduct": "Dodaj produkt",
      "calculator.users": "Użytkownicy Business Phone",
      "calculator.usersLabel": "Użytkownicy",
      "calculator.total": "Suma",
      "calculator.totalPerMonth": "Suma miesięczna",
      "calculator.generateOffer": "Generuj ofertę",
      "calculator.placeholderAdd": "Dodaj przynajmniej jeden produkt, aby obliczyć koszt",
      "calculator.selectRegion": "Wybierz region",
      
      // Produkty
      "calculator.businessPhone": "Business Phone",
      "calculator.callTracking": "Call Tracking",
      "calculator.ai": "Analityka rozmów AI",
      "calculator.callback": "Callback",
      "calculator.phoneNumbers": "Numery telefonów",
      "calculator.voiceTraffic": "Pakiety minut",
      "calculator.omnichannelChat": "Czat omnikanałowy",
      "calculator.aiConversation": "Analityka rozmów AI",
      "calculator.aiConversationLabel": "Analityka rozmów AI",
      
      // Podstawowe działania
      "calculator.cancel": "Anuluj",
      "calculator.apply": "Zastosuj",
      "calculator.add": "Dodaj",
      "calculator.update": "Aktualizuj",
      "common.ok": "OK",
      "common.cancel": "Anuluj",
      "common.apply": "Zastosuj",
      "common.close": "Zamknij",
      "common.reset": "Resetuj",

      // Tłumaczenia dla strony logowania
      "login.title": "Logowanie do kalkulatora cen Ringostat",
      "login.welcome": "Użyj swojego firmowego konta Google (@ringostat.com)",
      "login.continueWithGoogle": "Kontynuuj z Google",

      "calculator.omnichannelChatFmcInfo": "Omnichannel Chat jest dostępny tylko z Business Phone. Przy FMC edycja jest niedostępna.",
      "calculator.omnichannelChatLimitInfoWithValue": "Maksimum dla czatu — {{max}} (równe liczbie użytkowników Business Phone). Aby wpisać więcej w polu, najpierw zwiększ Business Phone.",
      
      // Sekcje
      "calculator.addProductsTitle": "Dodaj produkty",
      "calculator.selectedProductsTitle": "Wybrane produkty",
      "calculator.summary": "Podsumowanie",
      "calculator.estimatedTotal": "Szacunkowa suma",
      "calculator.currency": "Waluta",
      "calculator.noItemsSelected": "Nie wybrano produktów",
      "calculator.addProducts": "Dodaj produkty",
      "calculator.allProductsSelected": "Wybrałeś wszystkie dostępne produkty! 🎉",
      
      // Jednostki miary
      "calculator.sessions": "Sesje Call Tracking/dzień",
      "calculator.sessionsLabel": "Sesje",
      "calculator.sessionsInputLabel": "Sesji call tracking",
      "calculator.aiMinutesInputLabel": "Minut analityki AI",
      "calculator.callbackSessionsInputLabel": "Sesji callback",
      "calculator.businessPhoneUsers": "użytkowników",
      "calculator.fmcUsers": "użytkowników",
      "calculator.callTrackingSlots": "slotów",
      "calculator.aiMinutes": "minut",
      "calculator.callbackSessions": "sesji",
      "calculator.phoneNumbersCount": "numerów",
      "calculator.chatUsers": "użytkowników",
      "calculator.chatUsersLabel": "Liczba użytkowników",
      "calculator.minutes": "minut",
      "calculator.numbers": "numerów",
      "calculator.phoneNumberName": "Nazwa numeru",
      "calculator.quantity": "Ilość",
      
      // Voice Traffic
      "calculator.voiceTrafficMinutes": "Liczba minut ruchu głosowego miesięcznie",
      "calculator.voiceTrafficPackage": "Pakiet",
      "calculator.voiceTrafficPackageUA": "Pakiet minut UA",
      "calculator.voiceTrafficPackageKZ": "Pakiet minut KZ",
      "calculator.voiceTrafficPackageTooltip": "Wybierz pakiet ręcznie lub pozwól systemowi wybrać najbardziej opłacalny",
      "calculator.voiceTrafficSelectedPackages": "Wybrane pakiety",
      "calculator.voiceTrafficCustomAmount": "Zaliczka na połączenia",
      "calculator.voiceTrafficSettings": "Połączenia głosowe",
      "calculator.voiceTrafficCountries": "Kraje",
      "calculator.voiceTrafficCountriesDescription": "Wybierz kraje dla pakietów minut na połączenia. Możesz wybrać wiele krajów.",
      "calculator.voiceTrafficCustomAmountDescription": "Użyj niestandardowej kwoty zamiast automatycznego wyboru pakietu",
      "calculator.voiceTrafficSummary": "System automatycznie wybierze najlepsze pakiety dla {{count}} krajów w oparciu o Twoje potrzeby minutowe.",
      "calculator.voiceTrafficSelectedCountries": "Wybrane kraje: {{countries}}",
      "calculator.voiceTrafficCustomAmountInput": "Zaliczka na połączenia",
      "calculator.voiceTrafficPackageDetails": "{{includedMinutes}} minut w pakiecie",
      "calculator.voiceTrafficOverageMinutes": "dodatkowych minut",
      "calculator.voiceTrafficOverageText": "ponad pakiet",
      "calculator.voiceTrafficOverageShort": "ponad pakiet",
      "calculator.voiceTrafficPerMinute": "zł/min",
      "calculator.voiceTrafficCurrencyUAH": "hrn/min",
      "calculator.voiceTrafficCurrencyKZT": "tenge/min",
      "calculator.voiceTrafficCurrencyPLN": "zł/min",
      "calculator.voiceTrafficCurrencyEUR": "€/min",
      "calculator.voiceTrafficVolumeUA": "Wolumen połączeń wychodzących na Ukrainie",
      "calculator.voiceTrafficVolumeKZ": "Wolumen połączeń wychodzących w Kazachstanie",
      "calculator.voiceTrafficVolumePL": "Wolumen połączeń wychodzących w Polsce",
      "calculator.voiceTrafficMinutesShort": "min.",
      "calculator.voiceTrafficMinutesUnit": "minut",
      "calculator.voiceTrafficLabel": "Pakiet minut",
      "calculator.voiceTrafficDesc": "Liczba minut ruchu głosowego miesięcznie",
      
      // Plany subskrypcji
      "subscription.360Days": "360 dni (bonus 20%)",
      "subscription.360DaysCustom": "360 dni (bonus {{discount}}%)",
      "subscription.360DaysNoBonus": "360 dni",
      "subscription.180Days": "180 dni",
      "subscription.180DaysCustom": "180 dni (bonus {{discount}}%)",
      "subscription.90Days": "90 dni",
      "subscription.12MonthContract": "12-miesięczny kontrakt",
      "subscription.360DaysSplit": "360 dni (rata)",
      "subscription.toPay": "do zapłaty",
      "subscription.savings": "oszczędność",
      "subscription.perYear": "/rok",
      "subscription.perMonth": "/mies",
      "subscription.days": "dni",
      "subscription.bonus": "bonus",
      "subscription.splitPayment": "rata",
      "subscription.vatIncluded": "Z VAT 20%: {{amount}}",
      "calculator.discount360Days": "360-dniowa zniżka",
      "calculator.discount180Days": "180-dniowa zniżka",
      
      // Historia ofert
      "history.title": "Historia ofert",
      "history.description": "Przeglądaj i zarządzaj wszystkimi swoimi wygenerowanymi ofertami i porównaniami",
      "history.dateTime": "Data i czas",
      "history.type": "Typ",
      "history.userEmail": "Email użytkownika",
      "history.link": "Link",
      "history.offer": "Oferta",
      "history.comparison": "Porównanie",
      "history.noHistory": "Brak porównań",
      "history.createFirst": "Utwórz pierwsze porównanie w kalkulatorze",
      "history.openInNewTab": "Otwórz w nowej karcie",
      "history.copyLink": "Skopiuj link",
      "history.useAsTemplate": "Użyj jako szablonu",
      "history.templateUnavailable": "Dane szablonu są niedostępne",
      "history.copied": "Skopiowano!",
      "history.offers": "ofert",
      "history.offersInComparison": "Oferty w tym porównaniu",
      "history.clientName": "Nazwa firmy",
      "history.searchByClientName": "Szukaj po nazwie firmy...",
      "history.noClientName": "Brak nazwy firmy",
      "history.filters": "Filtry",
      "history.selectDateRange": "Wybierz zakres dat",
      
      // Oferty
      "offers.offerShareInfo": "Udostępnij ten link klientom, aby pokazać im szczegółową ofertę cenową.",
      "offers.comparisonGenerated": "Porównanie wygenerowane!",
      "offers.comparisonGeneratedDescription": "Twoje porównanie zostało pomyślnie utworzone",
      "offers.comparisonLink": "Link do porównania:",
      "offers.comparisonShareInfo": "Udostępnij ten link swoim klientom, aby mogli zobaczyć porównanie różnych opcji cenowych.",
      
      // Wybór dat
      "datePicker.today": "Dzisiaj",
      "datePicker.yesterday": "Wczoraj",
      "datePicker.last7Days": "Ostatnie 7 dni",
      "datePicker.last30Days": "Ostatnie 30 dni",
      "datePicker.currentMonth": "Bieżący miesiąc",
      "datePicker.previousMonth": "Poprzedni miesiąc",
      "datePicker.selectDateRange": "Wybierz zakres dat",
      "datePicker.quickSelect": "Szybki wybór",
      "datePicker.customRange": "Niestandardowy zakres",
      "datePicker.from": "Od",
      "datePicker.to": "Do",
      "datePicker.clear": "Wyczyść",
      
      // Oferty i propozycje handlowe
      "offers.notIncluded": "Nie zawarte",
      "offers.included": "W cenie",
      "offers.notAvailable": "Niedostępne",
      "offers.perMonth": "/mies",
      "offers.backToCalculator": "Powrót do kalkulatora",
      "offers.offerDetails": "Szczegóły oferty",
      "offers.comparisonCount": "Porównanie ({{count}}/5)",
      "offers.offersComparison": "Porównanie ofert",
      "offers.offersComparisonFor": "Porównanie ofert dla {{companyName}}",
      "offers.proposalFor": "Propozycja '{{offerName}}' dla {{companyName}}",
      "offers.proposalForCompany": "Propozycja dla {{companyName}}",
      "offers.proposalDetails": "Propozycja '{{offerName}}'",
      "offers.reviewOfferDetails": "Przejrzyj szczegóły oferty i wybierz plan cenowy",
      "offers.currencyDisclaimer": "Koszt formowany w dolarach, płatność w hrywnie po aktualnym kursie w dniu płatności",
      "comparison.noCompanyName": "Brak nazwy firmy",
      "offers.compareOffersDescription": "Porównaj różne oferty i wybierz najlepszą dla swojego biznesu",
      "offers.offer": "Oferta",
      "offers.productsAndUsage": "Produkty i użytkowanie",
      "offers.subscriptionOptions": "Opcje subskrypcji",
      "offers.available": "Dostępne",
      "offers.exportToPDF": "Eksport do PDF",
      "offers.validUntil": "Ważna do {{date}}",
      "offers.validUntilShort": "ważna do",
      "offers.validityPeriod": "14 dni od daty generacji",
      "offers.toPay": "do zapłaty",
      "offers.savePerYear": "Oszczędności",
      "offers.perYear": "/rok",
      "offers.plan360days20": "360 dni (bonus 20%)",
      "offers.savings": "Oszczędności",
      "offers.annualPayment": "płatność roczna",
      "offers.plan360daysNoBonus": "360 dni (bez bonusu)",
      "offers.plan180days": "180 dni (bonus 10%)",
      "offers.plan90days": "90 dni",
      "offers.plan12month": "12-miesięczny kontrakt",
      "offers.plan360split": "360 dni (płatność ratalna)",
      "offers.semiAnnualPayment": "za 6 miesięcy",
      "offers.detailedOffer": "Szczegółowa oferta",
      "offers.removeFromComparison": "Usuń z porównania",
      "offers.noOffersToCompare": "Brak ofert do porównania",
      "offers.returnToCalculatorToCreate": "Powróć do kalkulatora, aby utworzyć nowe oferty",
      "offers.generateOffer": "Utwórz ofertę",
      "offers.selectTabsDescription": "Wybierz konfiguracje cenowe do uwzględnienia w ofercie:",
      "offers.selectAll": "Wybierz wszystkie",
      "offers.configuration": "Konfiguracja",
      "offers.generateComparison": "Utwórz porównanie",
      "offers.offerGenerated": "Oferta utworzona!",
      "offers.offerGeneratedDescription": "Twoja oferta handlowa została pomyślnie utworzona",
      "offers.offerLink": "Link do oferty:",
      "offers.copyLink": "Skopiuj link",
      "offers.openInNewTab": "Otwórz w nowej karcie",
      "offers.linkCopied": "Link skopiowany do schowka!",
      "offers.yourProposal": "Twoja propozycja",
      "offers.monthlyForecast": "Szacowany koszt miesięczny",
      "offers.chooseThisPlan": "Wybierz ten plan",
      "offers.monthlyCost": "Koszt miesięczny",
      "offers.clientName": "Nazwa firmy *",
      "offers.clientNamePlaceholder": "Wprowadź nazwę firmy...",
      "offers.clientNameRequired": "Nazwa firmy jest wymagana",
      "offers.generating": "Tworzenie...",
      "offers.noTabsAvailable": "Brak dostępnych konfiguracji cenowych",
      
      // Dodatkowe ogólne tłumaczenia
      "common.backToCalculator": "Powrót do kalkulatora",
      "Settings": "Ustawienia",
      "Region": "Region",
      "Initial Data": "Dane początkowe",
      "Service Cost": "Koszt usług",
      "Business Phone": "Telefon biznesowy",
      "Call Tracking": "Call Tracking",
      "Total": "Razem",
      
      // Kraje
      "countries.ukraine": "Ukraina",
      "countries.kazakhstan": "Kazachstan",
      "countries.poland": "Polska",
      "voicePackages.noPackagesHint": "Niektóre kraje są niedostępne — brak aktywnych pakietów minut",

      // Kalkulator - rozszerzone ustawienia
      "calculator.aiConversationCalls": "połączeń",
      "calculator.monthlyForecast": "Szacowany koszt miesięczny",
      "calculator.minute": "minuta",
      "calculator.pricePerMinute": "Cena za minutę",
      "calculator.totalPrice": "Cena całkowita",
      "calculator.customSettingsEnabled": "Ustawienia niestandardowe włączone",
      "calculator.aiSettingsTitle": "Ustawienia AI analizy rozmów",
      "calculator.enableNonEnglishAnalysis": "Włącz analizę w innych językach",
      "calculator.nonEnglishAnalysisTooltip": "Ujednolicona cena: $0.03 za minutę dla wszystkich regionów (z wyjątkiem Europy: €0.03)",
      "calculator.resetToDefault": "Przywróć ustawienia domyślne",
      "calculator.pricingInformation": "Informacje o cenach:",
      "calculator.standardAnalysis": "Analiza standardowa:",
      "calculator.nonEnglishAnalysis": "Analiza w innych językach:",
      "calculator.monthlyTotal": "Koszt miesięczny",
      "calculator.paymentOptions": "Opcje płatności",
      "calculator.paymentSummary": "Podsumowanie płatności",
      "calculator.standardPlan": "360 dni",
      "calculator.bestValue": "Najlepsza oferta - ",
      "calculator.sixMonthPlan": "Subskrypcja na 180 dni",
      "calculator.threeMonthMinimum": "Subskrypcja na 90 dni",
      "calculator.monthlyContract": "12-miesięczny kontrakt",
      "calculator.splitPayment": "Subskrypcja na 360 dni (płatność ratalna)",
      "calculator.moreExpensivePerYear": "drożej rocznie",
      "calculator.advancedDiscountSettings": "Zaawansowane ustawienia zniżek",
      "calculator.advancedDiscountHint": "Naciśnij Cmd+Shift+D (Mac) lub Ctrl+Shift+D (PC) aby ukryć",
      "calculator.businessPhoneUsersLabel": "Liczba użytkowników telefonu biznesowego",
      "calculator.businessPhoneUsersLabelStandalone": "Liczba użytkowników",
      "calculator.fmcUsersLabel": "Liczba użytkowników FMC",
      "calculator.fmcUsersLabelStandalone": "Liczba użytkowników",
      "calculator.businessPhoneSettings": "Ustawienia Business Phone",
      "calculator.businessPhoneType": "Typ Business Phone",
      "calculator.businessPhoneOnly": "Business Phone",
      "calculator.fmcOnly": "FMC",
      "calculator.businessPhoneFmc": "Business Phone + FMC",
      "calculator.businessPhonePricing": "Business Phone: €20 za użytkownika",
      "calculator.fmcPricing": "FMC: $5 za użytkownika",
      "calculator.comparePlans": "Porównaj",
      "calculator.compareFeatures": "Porównaj funkcje",
      "calculator.comparePlansTitle": "Porównanie planów",
      "calculator.feature": "Funkcja",
      "calculator.selected": "Wybrano",
      "calculator.compareTip": "Kliknij na kolumnę planu, aby go wybrać",
      "calculator.included": "W CENIE",
      "calculator.includedInTier": "Zawarte w planie {{tier}}",
      "calculator.includedInProCorporate": "Zawarte w planie Pro/Corporate",
      "calculator.perUser": "/użytkownik",
      "calculator.comingSoon": "Wkrótce",
      "calculator.uaBusinessDiscount": "Zniżka dla ukraińskiego biznesu",
      "calculator.features.aiConversation": "Analiza rozmów (AI)",
      "calculator.features.aiConversationBasicLevel": "Podstawowy",
      "calculator.features.aiConversationProLevel": "Profesjonalny Eniq AI",
      "calculator.features.omnichannelChat": "Czat wielokanałowy",
      "calculator.features.callback": "Callback",
      "calculator.features.realTimeReports": "Raporty w czasie rzeczywistym",
      "calculator.features.agentStatuses": "Statusy agentów",
      "calculator.features.callWhisper": "Tryb suflera",
      "calculator.features.csat": "CSAT",
      "calculator.features.customerSuccessTeam": "Customer Success",
      "calculator.features.powerDialer": "Power Dialer",
      "calculator.features.autoMissedProcessing": "Automatyzacja nieodebranych",
      "calculator.features.prioritySupport": "Priorytetowe wsparcie",
      "calculator.features.dedicatedVipCs": "VIP Customer Success",
      "calculator.features.customLookerReports": "Raporty Looker Studio",
      "calculator.features.customUserRoles": "Elastyczne ustawienia ról",
      "calculator.features.customCrmIntegration": "Integracja CRM",
      "calculator.eniqCompare.title": "Porównanie planów Eniq AI",
      "calculator.eniqCompare.note": "Cena za jednego użytkownika miesięcznie",
      "calculator.eniqCompare.models": "Modele AI",
      "calculator.eniqCompare.modelsStandard": "Modele standardowe",
      "calculator.eniqCompare.modelsPro": "Modele premium",
      "calculator.eniqCompare.promptLimit": "Długość promptu analizy",
      "calculator.eniqCompare.promptLimitStandard": "Do 30k znaków",
      "calculator.eniqCompare.promptLimitPro": "Bez limitu",
      "calculator.eniqCompare.insights": "AI Insights",
      "calculator.eniqCompare.insightsStandard": "Limity standardowe",
      "calculator.eniqCompare.insightsPro": "Limity rozszerzone",
      "calculator.eniqCompare.knowledgeBase": "Baza wiedzy",
      "calculator.eniqCompare.knowledgeBaseStandard": "Limity standardowe",
      "calculator.eniqCompare.knowledgeBasePro": "Limity rozszerzone",
      "calculator.eniqCompare.training": "Trening AI",
      "calculator.eniqCompare.trainingStandard": "1 godzina na użytkownika",
      "calculator.eniqCompare.trainingPro": "Limit rozszerzony",
      "calculator.eniqTierLabel": "Plan Eniq AI",
      "calculator.eniqTierStandard": "Standard",
      "calculator.eniqTierPro": "Pro",
      "calculator.eniqUsersLabel": "Liczba użytkowników",
      "calculator.eniqUsersLinkedInfo": "Liczba użytkowników Eniq AI jest powiązana z Business Phone/FMC",
      "calculator.eniqUpgradeDiff": "Standard jest w Corporate — dopłacasz tylko różnicę",
      "calculator.eniqMinBillableUsers": "Eniq AI jest zawsze rozliczany za minimum {{count}} użytkowników",
      "calculator.fmcRegionWarning.title": "Ostrzeżenie o zmianie regionu",
      "calculator.fmcRegionWarning.message": "Przełączasz na region, w którym produkt FMC nie jest obsługiwany. FMC zostanie usunięte z Twojego wyboru. Czy chcesz kontynuować?",
      "calculator.fmcRegionWarning.confirm": "Zmień region",
      "calculator.callTrackingSettings": "Ustawienia Call Tracking",
      "calculator.trackingType": "Typ śledzenia",
      "calculator.dynamicTracking": "Dynamiczny (na podstawie sesji)",
      "calculator.staticTracking": "Statyczny (numer przypisany do konkretnego źródła)",
      "calculator.combinedTracking": "Kombinowany (dynamiczny + statyczny)",
      "calculator.enableCallMeButton": "Włącz przycisk \"Zadzwoń do mnie\"",
      "calculator.numberFormatsQuantity": "Ilość formatów numerów",
      "calculator.globalSettings": "Ustawienia globalne",
      "calculator.globalSettingsPlaceholder": "Ustawienia globalne będą dostępne tutaj",
      "calculator.showAdvancedTier": "Pokaż plan Advanced",
      "calculator.showAdvancedTierDescription": "Włącz ukryty plan Advanced dla Business Phone (UA, Central Asia, Other regiony)",
      "calculator.showPricesWithoutBonuses": "Wyświetlaj ceny bez długoterminowych bonusów",
      "calculator.showPricesWithoutBonusesDescription": "Prognoza miesięcznej opłaty pokaże ceny bez zniżki za 360-dniową subskrypcję",
      "calculator.subscriptionOptions": "Opcje subskrypcji",
      "calculator.subscription12Month": "12-miesięczny kontrakt",
      "calculator.subscriptionSplitPayment": "Płatność ratalna",
      "calculator.legacyOptions": "Legacy Options",
      "calculator.subscription90Days": "Subskrypcja na 90 dni",
      "calculator.subscription180Days": "Subskrypcja na 180 dni",
      "calculator.unitPrice": "Cena jednostkowa",
      "calculator.noPhoneNumbers": "Numery telefonów nie zostały jeszcze dodane. Kliknij \"Dodaj numer telefonu\" aby dodać.",
      "calculator.addPhoneNumber": "Dodaj numer telefonu",
      "calculator.addFromCatalog": "Dodaj z katalogu",
      "calculator.pleaseEnterName": "Proszę wprowadzić nazwę numeru telefonu",
      "calculator.allProductsAdded": "Wszystkie dostępne produkty zostały dodane",
      "calculator.dailyWebsiteSessions": "Ilość sesji na stronie dziennie",
      "calculator.staticSourcesDescription": "Źródła statyczne (1 źródło = 1 numer telefonu)",
      "calculator.minutesToAnalyze": "Liczba minut do analizy miesięcznie",
      "calculator.aiUsersLabel": "Liczba użytkowników",
      "calculator.aiUsersLinkedInfo": "Liczba użytkowników AI jest powiązana z liczbą użytkowników Business Phone/FMC",
      "calculator.chatUsersLinkedInfo": "Liczba użytkowników czatu jest powiązana z liczbą użytkowników Business Phone (użytkownicy FMC nie mogą korzystać z czatu)",
      "calculator.phoneNumbersRequired": "Wymagane numery telefonów",

      // Eniq AI tłumaczenia
      "calculator.eniqAiLabel": "Eniq AI",
      "calculator.eniqAiDesc": "Analiza rozmów przez AI",
      "calculator.eniqAiMinutes": "Minuty analizy",
      "calculator.eniqAiMinutesInput": "Liczba minut",
      "calculator.eniqAiUnits": "tokenów",
      "calculator.eniqAiPremiumModels": "Modele premium",
      "calculator.eniqAiSettings": "Ustawienia Eniq AI",
      "calculator.eniqAiAnalysisType": "Typ analizy",
      "calculator.eniqAiPremiumDescription": "Analiza wysokiej dokładności z zaawansowanymi modelami AI (1 kredyt za minutę)",
      "calculator.eniqAiStandardNote": "Modele standardowe",
      "calculator.eniqAiStandardDescription": "Ekonomiczna analiza ze standardowymi modelami AI (0.33 kredytu za minutę)",
      "calculator.eniqAiDescription": "Analiza rozmów przez AI z elastycznymi planami taryfowymi w zależności od potrzeb.",
      "calculator.eniqAiOptimalPlan": "Plan optymalny",
      "calculator.eniqAiIncluded": "minut w zestawie",
      "calculator.eniqAiExtraMinutes": "dodatkowych minut",
      "calculator.eniqAiUnitsIncluded": "tokenów w zestawie",
      "calculator.eniqAiExtraUnits": "dodatkowych tokenów",
      "calculator.eniqAiTariff": "Plan",
      "calculator.eniqAiCalculationError": "Nie udało się obliczyć kosztu",
      "calculator.calculating": "Obliczanie...",
      "calculator.eniqAiPlanStart": "Start",
      "calculator.eniqAiPlanPro": "Pro",
      "calculator.eniqAiPlanMax": "Max",
      "calculator.eniqAiPlanScale": "Scale",

      // VoiceBot
      "calculator.voicebotLabel": "Bot głosowy",
      "calculator.voicebotDesc": "Automatyczne rozmowy telefoniczne z AI",
      "calculator.voicebotMinutesInput": "Liczba minut",
      "calculator.voicebotMinutesUnit": "min",
      "calculator.voicebotSettings": "Ustawienia VoiceBot",
      "calculator.voicebotMode": "Tryb kampanii",
      "calculator.voicebotAiMode": "AI VoiceBot",
      "calculator.voicebotAiDescription": "Rozmowy AI (1000 jednostek za minutę)",
      "calculator.voicebotRoboCallMode": "RoboCall",
      "calculator.voicebotRoboCallDescription": "Automatyczne rozmowy bez AI (100 jednostek za minutę)",
      "calculator.voicebotExtraChannels": "Dodatkowe robo-kanały",
      "calculator.voicebotChannelsIncluded": "3 kanały w każdym planie",
      "calculator.voicebotExtraChannelsCount": "Dodatkowe kanały",
      "calculator.voicebotChannelPrice": "$25/mies za kanał",
      "calculator.voicebotTotalChannels": "kanałów łącznie",
      "calculator.voicebotPerMonth": "mies.",
      "calculator.voicebotImplementationFee": "Opłata wdrożeniowa",
      "calculator.voicebotImplementationFeeLabel": "Wdrożenie VoiceBot",
      "calculator.voicebotImplementationFeeDesc": "Jednorazowa opłata za wdrożenie i konfigurację VoiceBot",
      "calculator.voicebotMinIncluded": "min w zestawie",
      "calculator.voicebotExtraMin": "dodatkowych min",
      "calculator.planLite": "Lite",
      "calculator.tariff": "Plan",

      // Ustawienia zaawansowane
      "calculator.advancedSettings": "Ustawienia zaawansowane",
      "calculator.veryCustomProductDiscount": "Niestandardowa zniżka produktu",
      "calculator.customDiscountNote": "Stosowane po zniżkach pakietowych (0-100%)",
      "calculator.advancedSettingsHint": "Dostęp: Podwójne kliknięcie tytułu lub Ctrl+Shift+C",
      "calculator.omnichannelChatSettings": "Ustawienia Czatu Omnichannel",
      "calculator.omnichannelChatSettingsDescription": "Obecnie nie ma dodatkowych ustawień dostępnych dla Czatu Omnichannel.",

      // Brakujące klucze dla zgodności z EN/UA
      "admin.syncDIDWW": "Synchronizuj DIDWW Docs",
      "admin.syncDIDWWAlreadyRunning": "Synchronizacja już trwa",
      "admin.syncDIDWWError": "Nie udało się zsynchronizować wymagań DIDWW",
      "admin.syncDIDWWStarted": "Synchronizacja DIDWW rozpoczęta, proszę czekać...",
      "admin.syncDIDWWSuccess": "Zsynchronizowano {{countries}} krajów, zaktualizowano {{entries}} wpisów",
      "admin.syncDIDWWSyncing": "Synchronizacja...",
      "calculator.addMore": "+ Dodaj więcej",
      "calculator.addPhoneNumbers": "Dodaj numery telefonów",
      "calculator.aiConversationDesc": "Liczba minut do analizy miesięcznie",
      "calculator.betaPricing": "Cena beta: zastosowano 50% zniżki",
      "calculator.betaProduct": "BETA -50%",
      "calculator.businessPhoneDesc": "Liczba użytkowników potrzebujących funkcji Business Phone",
      "calculator.businessPhoneLabel": "Business Phone",
      "calculator.callTrackingDesc": "Sesje na stronie dziennie",
      "calculator.callTrackingLabel": "Call Tracking",
      "calculator.callbackDesc": "Szacowana liczba zgłoszeń Callback miesięcznie",
      "calculator.callbackLabel": "Callback",
      "calculator.docsRequired": "Wymagane dokumenty",
      "calculator.editPhoneNumbers": "Edytuj numery telefonów",
      "calculator.fmcLabel": "FMC",
      "calculator.fromCatalog": "Z katalogu",
      "calculator.offerPageDesc": "Ta strona pokaże wygenerowaną ofertę handlową dla klienta z brandingiem Ringostat.",
      "calculator.offerPageTitle": "Oferta (demo)",
      "calculator.omnichannelChatDesc": "Użytkownicy czatu online i komunikatorów (Viber, Telegram, Facebook)",
      "calculator.omnichannelChatWarning": "Czat Omnichannel wymaga wcześniejszego dodania Business Phone.",
      "calculator.omnichannelChatWarning.title": "Wymagania produktu",
      "calculator.phoneNamePlaceholder": "Wpisz, aby wyszukać w katalogu...",
      "calculator.phoneNumbersDesc": "Zakup i zarządzanie numerami telefonów",
      "calculator.pricePerNumber": "Cena za numer",
      "calculator.usersInputLabel": "Użytkownicy Business Phone",
      "common.create": "Utwórz",
      "common.delete": "Usuń",
      "common.save": "Zapisz",
      "voicePackages.actions": "Działania",
      "voicePackages.active": "Aktywny",
      "voicePackages.addPackage": "Dodaj pakiet",
      "voicePackages.adjustFilters": "Spróbuj zmienić filtry",
      "voicePackages.allCountries": "Wszystkie",
      "voicePackages.confirmDelete": "Usunąć pakiet?",
      "voicePackages.confirmDeleteText": "Czy na pewno chcesz usunąć \"{{name}}\" ({{country}})?",
      "voicePackages.country": "Kraj",
      "voicePackages.created": "Pakiet utworzony",
      "voicePackages.currency": "Waluta",
      "voicePackages.delete": "Usuń",
      "voicePackages.deleteError": "Nie udało się usunąć pakietu",
      "voicePackages.deleted": "Pakiet usunięty",
      "voicePackages.edit": "Edytuj",
      "voicePackages.editPackage": "Edytuj pakiet",
      "voicePackages.fetchError": "Nie udało się załadować pakietów",
      "voicePackages.isActive": "Aktywny",
      "voicePackages.loading": "Ładowanie pakietów...",
      "voicePackages.minutes": "Minuty",
      "voicePackages.name": "Nazwa",
      "voicePackages.noEntries": "Nie znaleziono pakietów",
      "voicePackages.overageLocal": "Nadwyżka lokalna",
      "voicePackages.overageRateLocal": "Stawka nadwyżki lokalnej",
      "voicePackages.overageUsd": "Nadwyżka USD",
      "voicePackages.perMinLocal": "Za min. lokalnie",
      "voicePackages.perMinUsd": "Za min. USD",
      "voicePackages.priceLocal": "Cena lokalna",
      "voicePackages.pricePerMinuteLocal": "Cena za minutę lokalnie",
      "voicePackages.priceUsd": "Cena USD",
      "voicePackages.searchPlaceholder": "Szukaj po nazwie...",
      "voicePackages.showingEntries": "Wyświetlono {{showing}} z {{total}} wpisów",
      "voicePackages.subtitle": "Zarządzanie pakietami minut ruchu głosowego",
      "voicePackages.title": "Pakiety minut",
      "voicePackages.toggleError": "Nie udało się zmienić statusu",
      "voicePackages.updated": "Pakiet zaktualizowany",
      "voicePackages.usdInfo": "Ceny w USD są aktualizowane automatycznie przez codzienne zadanie cron",
      
      // Waluty
      "currency.display": "Waluta",
      "currency.uahNote": "Ceny są ustalane w dolarach, płatność jest dokonywana w hrywnach po kursie z dnia płatności.",
      "currency.uah": "UAH",
      "currency.uahSymbol": "UAH",
      "currency.usd": "USD",
      "currency.eur": "EUR",
      
      // Krótkie tłumaczenia
      "calculator.perMonthShort": "/mies",
      
      // Płatności jednorazowe
      "calculator.oneTimePayments": "Płatności jednorazowe",
      "calculator.phoneNumberActivation": "Aktywacja numerów telefonów",
      "calculator.eniqImplementationFee": "Wdrożenie Eniq AI",
      "calculator.enableImplementationFee": "Opłata za wdrożenie",
      "calculator.implementationFeeDescription": "Jednorazowa opłata za wdrożenie i konfigurację Eniq AI",
      "calculator.implementationFeeAmount": "Kwota wdrożenia",
      
      // Ustawienia numerów telefonów
      "calculator.phoneNumbersSettings": "Ustawienia numerów telefonów",
      "calculator.enablePhoneActivation": "Włącz opłatę aktywacyjną",
      "calculator.activationFee": "Koszt aktywacji",
      "calculator.activationTotal": "Opłata aktywacyjna",

      // Selected Plan Features
      "calculator.selectedPlanIncludes": "Wybrany plan zawiera",

      // Basic tier features
      "calculator.feature.mobileDesktopApps": "Aplikacje desktopowe i mobilne",
      "calculator.feature.callRecordingUnlimited": "Nieograniczone nagrywanie",
      "calculator.feature.integrations50": "50+ gotowych integracji",
      "calculator.feature.reportsControlMissed": "Raporty i statystyki",
      "calculator.feature.flexibleRouting": "Elastyczny routing",
      "calculator.feature.ivrVoicemail": "IVR, poczta głosowa",

      // Pro tier features
      "calculator.feature.allBasicFeatures": "Wszystkie funkcje planu Basic",
      "calculator.feature.callTranscription": "Transkrypcja rozmów",
      "calculator.feature.aiQualityScoring": "Ocena jakości rozmów (AI)",
      "calculator.feature.omnichannelMessengers": "Czat i komunikatory",
      "calculator.feature.callbackWidget": "Widget callback",
      "calculator.feature.advancedReportsSchedule": "Zaawansowane raporty",

      // Corporate tier features
      "calculator.feature.allProFeatures": "Wszystkie funkcje planu Pro",
      "calculator.feature.advancedConversationAnalytics": "Zaawansowana analiza rozmów",
      "calculator.feature.powerDialer": "Power Dialer",
      "calculator.feature.missedCallsAutomation": "Autoobsługa nieodebranych",
      "calculator.feature.personalManager": "Osobisty opiekun",
      "calculator.feature.prioritySupport": "Priorytetowe wsparcie",
      "calculator.feature.customReportsCrm": "Raporty i integracje",

      // Tabs
      "tabs.newCalculation": "Nowa kalkulacja",
      "tabs.allCalculations": "Wszystkie kalkulacje",

      // Test Scenarios Dashboard
      "testScenarios.title": "Panel scenariuszy testowych",
      "testScenarios.subtitle": "Wizualizacja i walidacja scenariuszy cenowych",
      "testScenarios.info": "Ten panel pokazuje wszystkie scenariusze testowe cenowe. Kliknij \"Zastosuj\" aby utworzyć nową zakładkę kalkulatora z konfiguracją scenariusza.",
      "testScenarios.backToCalculator": "Powrót do kalkulatora",
      "testScenarios.total": "Razem: {{count}}",
      "testScenarios.passed": "Zaliczone: {{count}}",
      "testScenarios.failed": "Niezaliczone: {{count}}",
      "testScenarios.search": "Szukaj",
      "testScenarios.searchPlaceholder": "Szukaj po opisie...",
      "testScenarios.product": "Produkt",
      "testScenarios.tier": "Pakiet",
      "testScenarios.region": "Region",
      "testScenarios.status": "Status",
      "testScenarios.all": "Wszystkie",
      "testScenarios.passedOnly": "Zaliczone",
      "testScenarios.failedOnly": "Niezaliczone",
      "testScenarios.description": "Opis",
      "testScenarios.quantity": "Ilość",
      "testScenarios.expected": "Oczekiwane",
      "testScenarios.actual": "Rzeczywiste",
      "testScenarios.actions": "Akcje",
      "testScenarios.apply": "Zastosuj",
      "testScenarios.testPassed": "Test zaliczony",
      "testScenarios.testFailed": "Test niezaliczony",
      "testScenarios.noResults": "Brak scenariuszy pasujących do filtrów",
      "testScenarios.noConfig": "Brak konfiguracji kalkulatora dla tego scenariusza",
      "testScenarios.tabCreated": "Zakładka \"{{name}}\" utworzona! Skonfiguruj ręcznie lub sprawdź konfigurację scenariusza.",
      "testScenarios.applyError": "Błąd tworzenia zakładki",

      "admin.users": "Użytkownicy",
      "admin.usersManagement": "Zarządzanie użytkownikami",
      "admin.usersDescription": "Zarządzaj rolami użytkowników i przeglądaj aktywność",
      "admin.searchUsers": "Szukaj po email lub nazwie...",
      "admin.showingUsers": "Pokazano {{showing}} z {{total}} użytkowników",
      "admin.name": "Nazwa",
      "admin.email": "Email",
      "admin.role": "Rola",
      "admin.actions": "Akcje",
      "admin.loadingUsers": "Ładowanie użytkowników...",
      "admin.noUsers": "Nie znaleziono użytkowników",
      "admin.adjustSearch": "Spróbuj zmienić zapytanie",
      "admin.viewHistory": "Zobacz historię",
      "admin.roleUpdated": "Rola zaktualizowana pomyślnie",
      "admin.roleUpdateFailed": "Nie udało się zaktualizować roli",
      "admin.userHistory": "{{name}} — Historia",
      "admin.userHistoryShort": "Historia użytkownika",
      "admin.backToUsers": "Powrót do użytkowników",
      "admin.selectedCount": "{{count}} wybranych",
      "admin.selectRole": "Wybierz rolę...",
      "admin.applyRole": "Zastosuj",
      "admin.clearSelection": "Wyczyść wybór",
      "admin.bulkSuccess": "Zaktualizowano {{count}} użytkowników",
      "admin.bulkPartial": "Zaktualizowano {{success}}, błędów {{fail}}",

      "offer.heroTitle": "Oferta dla",
      "offer.yourProducts": "Twoje produkty",
      "offer.subscriptionOptions": "Opcje płatności",
      "offer.oneTimePayments": "Płatności jednorazowe",
      "offer.includedOneTimeFees": "Wliczone opłaty jednorazowe",
      "offer.addedToPlanBelow": "↓ Wliczone w subskrypcje poniżej",
      "comparison.oneTimeAddedToTotal": "*Wliczone w subskrypcję",
      "offer.oneTimeTotal": "Łącznie jednorazowo",
      "offer.advantages": "Dlaczego Ringostat?",
      "offer.contactTitle": "Masz pytania dotyczące tej oferty?",
      "offer.contactSubtitle": "Skontaktuj się bezpośrednio ze swoim opiekunem",
      "offer.contactSubtitleNamed": "Skontaktuj się bezpośrednio z {{name}}",
      "offer.callManager": "Zadzwoń do swojego eksperta",
      "offer.emailManager": "E-mail",
      "offer.salesRole": "Ekspert Ringostat",
      "offer.viewFullOffer": "Pokaż pełną ofertę",
      "offer.heroDescription": "Zarządzaj całą komunikacja, nie trać klientów i odciąż swój zespół od rutynowych zadań dzięki Ringostat — platformie komunikacyjnej z AI.",
      "offer.priceNote": "płatność roczna, bez VAT",
      "comparison.heroDescription": "Wybierz optymalne rozwiązanie dla swojego biznesu spośród zaproponowanych opcji. Każda oferta jest dopasowana do Twoich potrzeb.",
      "comparison.paymentOptionsHint": "Dłuższy okres — wyższy rabat",
      "comparison.variants": "{{count}} opcje",
      "comparison.yourOptions": "Twoje opcje",
      "comparison.products": "produkty",
      "comparison.perYear": "/rok",
      "comparison.product": "Produkt",
      "comparison.totalMonthly": "Razem / mies.",
      "comparison.detailedComparison": "Szczegółowe porównanie",
      "offer.comparePlans": "Porównaj plany Business Phone",
      "offer.comparisonTitle": "Porównanie ofert dla {{client}}",
      "offer.included": "Wliczone",
      "offer.annualPlan": "Plan roczny",
      "offer.saveBadge": "Oszczędź {{percent}}%",
      "offer.recommended": "Rekomendowane",
      "offer.validUntil": "Ważna do {{date}}",
      "offer.perMonth": "/mies.",
      "offer.perYear": "/rok",
      "offer.totalAnnual": "Razem: {{amount}}/rok",
      "advantages.iso.title": "Certyfikat ISO 27001",
      "advantages.iso.desc": "Dane chronione zgodnie z międzynarodowymi standardami bezpieczeństwa",
      "offer.toPay": "do zapłaty",
      "offer.withVat": "Z VAT 20%: {{amount}}",
      "offer.exportPDF": "Eksportuj PDF",
      "offer.oneTimePaymentHint": "Jednorazowa opłata konfiguracyjna",
      "offer.perMonthLabel": "miesięcznie",
      "offer.acceptRecommendation": "Zaakceptuj rekomendację",
      "offer.selectPlan": "Wybierz plan",
      "offer.saveBullet": "Oszczędność {{percent}}%",
      "offer.priceLocked": "Cena zablokowana na 12 miesięcy",
      "offer.dedicatedManager": "Dedykowany opiekun",
      "offer.subscriptionBadge": "Plan {{days}}-dniowy",
      "advantages.apps.title": "Aplikacje na wszystkie platformy",
      "advantages.apps.desc": "Natywne aplikacje na iOS, Android, Windows i macOS. Korzystanie z Ringostat jest proste i wygodne",
      "advantages.crm.title": "Elastyczne integracje z ponad 50 CRM",
      "advantages.crm.desc": "Płynna integracja z Salesforce, HubSpot, Pipedrive, ZohoCRM i innymi systemami, dopasowana do procesów biznesowych",
      "advantages.missed.title": "Zapobieganie utracie klientów",
      "advantages.missed.desc": "Elastyczna dystrybucja połączeń, aplikacje mobilne i wygodna obsługa nieodebranych połączeń",
      "advantages.support.title": "Wsparcie, na które zasługujesz",
      "advantages.support.desc": "95% klientów ocenia nasze wsparcie jako \"Dobre\" lub \"Doskonałe\". Średni czas odpowiedzi — 2 minuty",
      "advantages.recordings.title": "Nielimitowane nagrania rozmów",
      "advantages.recordings.desc": "Bezpłatne, nielimitowane przechowywanie nagrań rozmów we wszystkich planach",
      "advantages.analytics.title": "Zaawansowana analityka i raportowanie",
      "advantages.analytics.desc": "Dashboardy w czasie rzeczywistym, raporty niestandardowe i insighty AI dla każdej rozmowy",
      "advantages.ukraine.title": "Krystalicznie czysta jakość połączeń",
      "advantages.ukraine.desc": "Czysty SIP bez bramek GSM — wysoka stabilność i doskonała jakość głosu w każdej rozmowie",
      "calculator.phoneCatalog": "Katalog numerów",
      "calculator.addToOffer": "Dodaj do oferty",
      "calculator.itemsSelected": "{{count}} wybrano",
      "calculator.fromPrice": "OD",
      "calculator.fromPriceHint": "Cena zaczyna się od tej kwoty",
      "calculator.noResults": "Nie znaleziono numerów",
      "calculator.selectCountry": "Kraj",
      "calculator.selectCity": "Miasto",
      "calculator.selectProvider": "Dostawca",
      "calculator.searchNumbers": "Szukaj...",
      "calculator.monthlyFee": "Opłata miesięczna",
      "calculator.country": "Kraj",
      "calculator.city": "Miasto",
      "calculator.provider": "Dostawca",
      "calculator.code": "Kod",
      "calculator.docsShort": "Dok.",
      "calculator.commentShort": "Uwaga",
      "calculator.requiredDocs": "Wymagane dokumenty",
      "calculator.commentTitle": "Uwaga",
      "calculator.freeForTrial": "Trial",
      "calculator.freeForTrialYes": "Darmowe na trial",

      "profile.title": "Uzupełnij swój profil",
      "profile.editTitle": "Edytuj profil",
      "profile.firstName": "Imię",
      "profile.lastName": "Nazwisko",
      "profile.phone": "Telefon firmowy",
      "profile.phoneExtension": "Numer wewnętrzny",
      "profile.phoneExtensionHelper": "Kod pracownika IVR (2-6 cyfr)",
      "profile.uploadPhoto": "Prześlij zdjęcie",
      "profile.changePhoto": "Zmień zdjęcie",
      "profile.save": "Zapisz",
      "profile.saving": "Zapisywanie...",
      "profile.cropTitle": "Przytnij zdjęcie",
      "profile.cropConfirm": "Zastosuj",
      "profile.cropCancel": "Anuluj",
      "profile.menuItem": "Mój profil",
      "profile.required": "To pole jest wymagane",
      "profile.latinOnly": "Tylko znaki łacińskie",
      "profile.invalidPhone": "Telefon musi zaczynać się od + i zawierać 7-15 cyfr",
      "profile.invalidExtension": "Numer wewnętrzny musi zawierać 2-6 cyfr",
      "profile.photoRequired": "Proszę przesłać zdjęcie profilowe",
      "profile.subtitle": "Uzupełnij swoje dane, aby kontynuować korzystanie z kalkulatora",
      "profile.photoUploadRequired": "Prześlij własne zdjęcie",
      "profile.photoUploadExplanation": "Awatar z Google jest pokazywany jako podgląd, ale nie można go użyć. Kliknij \"Prześlij zdjęcie z komputera\" powyżej i wybierz plik ze swojego komputera — to jedyny sposób, aby aktywować przycisk \"Zapisz\".",
      "profile.phoneFormatHelper": "Tylko format międzynarodowy, bez spacji i symboli. Przykład: +48739109524",
      "profile.uploadPhotoFromComputer": "Prześlij zdjęcie z komputera",
      "profile.saveFailed": "Nie udało się zapisać profilu. Spróbuj ponownie lub skontaktuj się ze wsparciem."
    }
  }
};

export default resources;
